/* Swiper 11 — extracted from the redesign bundle.
   Still every page: gigli-topbar (header-group) instantiates it. Split out for caching and to enable per-page gating later.
   Loaded before gigli-bundle.js so its top-level const is in scope. */

function Ts(s) {
  return (
    s !== null &&
    typeof s == "object" &&
    "constructor" in s &&
    s.constructor === Object
  );
}
function Nr(s, e) {
  (s === void 0 && (s = {}),
    e === void 0 && (e = {}),
    Object.keys(e).forEach((t) => {
      typeof s[t] > "u"
        ? (s[t] = e[t])
        : Ts(e[t]) &&
          Ts(s[t]) &&
          Object.keys(e[t]).length > 0 &&
          Nr(s[t], e[t]);
    }));
}
const wo = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: "",
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {},
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      },
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
};
function ct() {
  const s = typeof document < "u" ? document : {};
  return (Nr(s, wo), s);
}
const Ga = {
  document: wo,
  navigator: {
    userAgent: "",
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {},
  },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      },
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(s) {
    return typeof setTimeout > "u" ? (s(), null) : setTimeout(s, 0);
  },
  cancelAnimationFrame(s) {
    typeof setTimeout > "u" || clearTimeout(s);
  },
};
function Ye() {
  const s = typeof window < "u" ? window : {};
  return (Nr(s, Ga), s);
}
function Kt(s) {
  return (
    s === void 0 && (s = ""),
    s
      .trim()
      .split(" ")
      .filter((e) => !!e.trim())
  );
}
function Xa(s) {
  const e = s;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {}
    try {
      delete e[t];
    } catch {}
  });
}
function Tn(s, e) {
  return (e === void 0 && (e = 0), setTimeout(s, e));
}
function Cn() {
  return Date.now();
}
function Ya(s) {
  const e = Ye();
  let t;
  return (
    e.getComputedStyle && (t = e.getComputedStyle(s, null)),
    !t && s.currentStyle && (t = s.currentStyle),
    t || (t = s.style),
    t
  );
}
function Ua(s, e) {
  e === void 0 && (e = "x");
  const t = Ye();
  let i, n, o;
  const l = Ya(s);
  return (
    t.WebKitCSSMatrix
      ? ((n = l.transform || l.webkitTransform),
        n.split(",").length > 6 &&
          (n = n
            .split(", ")
            .map((c) => c.replace(",", "."))
            .join(", ")),
        (o = new t.WebKitCSSMatrix(n === "none" ? "" : n)))
      : ((o =
          l.MozTransform ||
          l.OTransform ||
          l.MsTransform ||
          l.msTransform ||
          l.transform ||
          l
            .getPropertyValue("transform")
            .replace("translate(", "matrix(1, 0, 0, 1,")),
        (i = o.toString().split(","))),
    e === "x" &&
      (t.WebKitCSSMatrix
        ? (n = o.m41)
        : i.length === 16
          ? (n = parseFloat(i[12]))
          : (n = parseFloat(i[4]))),
    e === "y" &&
      (t.WebKitCSSMatrix
        ? (n = o.m42)
        : i.length === 16
          ? (n = parseFloat(i[13]))
          : (n = parseFloat(i[5]))),
    n || 0
  );
}
function Bi(s) {
  return (
    typeof s == "object" &&
    s !== null &&
    s.constructor &&
    Object.prototype.toString.call(s).slice(8, -1) === "Object"
  );
}
function Za(s) {
  return typeof window < "u" && typeof window.HTMLElement < "u"
    ? s instanceof HTMLElement
    : s && (s.nodeType === 1 || s.nodeType === 11);
}
function lt() {
  const s = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ["__proto__", "constructor", "prototype"];
  for (let t = 1; t < arguments.length; t += 1) {
    const i = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (i != null && !Za(i)) {
      const n = Object.keys(Object(i)).filter((o) => e.indexOf(o) < 0);
      for (let o = 0, l = n.length; o < l; o += 1) {
        const c = n[o],
          u = Object.getOwnPropertyDescriptor(i, c);
        u !== void 0 &&
          u.enumerable &&
          (Bi(s[c]) && Bi(i[c])
            ? i[c].__swiper__
              ? (s[c] = i[c])
              : lt(s[c], i[c])
            : !Bi(s[c]) && Bi(i[c])
              ? ((s[c] = {}), i[c].__swiper__ ? (s[c] = i[c]) : lt(s[c], i[c]))
              : (s[c] = i[c]));
      }
    }
  }
  return s;
}
function an(s, e, t) {
  s.style.setProperty(e, t);
}
function So(s) {
  let { swiper: e, targetPosition: t, side: i } = s;
  const n = Ye(),
    o = -e.translate;
  let l = null,
    c;
  const u = e.params.speed;
  ((e.wrapperEl.style.scrollSnapType = "none"),
    n.cancelAnimationFrame(e.cssModeFrameID));
  const p = t > o ? "next" : "prev",
    h = (b, w) => (p === "next" && b >= w) || (p === "prev" && b <= w),
    m = () => {
      ((c = new Date().getTime()), l === null && (l = c));
      const b = Math.max(Math.min((c - l) / u, 1), 0),
        w = 0.5 - Math.cos(b * Math.PI) / 2;
      let S = o + w * (t - o);
      if (
        (h(S, t) && (S = t),
        e.wrapperEl.scrollTo({
          [i]: S,
        }),
        h(S, t))
      ) {
        ((e.wrapperEl.style.overflow = "hidden"),
          (e.wrapperEl.style.scrollSnapType = ""),
          setTimeout(() => {
            ((e.wrapperEl.style.overflow = ""),
              e.wrapperEl.scrollTo({
                [i]: S,
              }));
          }),
          n.cancelAnimationFrame(e.cssModeFrameID));
        return;
      }
      e.cssModeFrameID = n.requestAnimationFrame(m);
    };
  m();
}
function xo(s) {
  return (
    s.querySelector(".swiper-slide-transform") ||
    (s.shadowRoot && s.shadowRoot.querySelector(".swiper-slide-transform")) ||
    s
  );
}
function Tt(s, e) {
  e === void 0 && (e = "");
  const t = Ye(),
    i = [...s.children];
  return (
    t.HTMLSlotElement &&
      s instanceof HTMLSlotElement &&
      i.push(...s.assignedElements()),
    e ? i.filter((n) => n.matches(e)) : i
  );
}
function Ka(s, e) {
  var i, n;
  const t = [e];
  for (; t.length > 0; ) {
    const o = t.shift();
    if (s === o) return !0;
    t.push(
      ...o.children,
      ...(((i = o.shadowRoot) == null ? void 0 : i.children) || []),
      ...(((n = o.assignedElements) == null ? void 0 : n.call(o)) || [])
    );
  }
}
function Qa(s, e) {
  const t = Ye();
  let i = e.contains(s);
  return (
    !i &&
      t.HTMLSlotElement &&
      e instanceof HTMLSlotElement &&
      ((i = [...e.assignedElements()].includes(s)), i || (i = Ka(s, e))),
    i
  );
}
function An(s) {
  try {
    console.warn(s);
    return;
  } catch {}
}
function Yi(s, e) {
  e === void 0 && (e = []);
  const t = document.createElement(s);
  return (t.classList.add(...(Array.isArray(e) ? e : Kt(e))), t);
}
function Ja(s) {
  const e = Ye(),
    t = ct(),
    i = s.getBoundingClientRect(),
    n = t.body,
    o = s.clientTop || n.clientTop || 0,
    l = s.clientLeft || n.clientLeft || 0,
    c = s === e ? e.scrollY : s.scrollTop,
    u = s === e ? e.scrollX : s.scrollLeft;
  return {
    top: i.top + c - o,
    left: i.left + u - l,
  };
}
function el(s, e) {
  const t = [];
  for (; s.previousElementSibling; ) {
    const i = s.previousElementSibling;
    (e ? i.matches(e) && t.push(i) : t.push(i), (s = i));
  }
  return t;
}
function tl(s, e) {
  const t = [];
  for (; s.nextElementSibling; ) {
    const i = s.nextElementSibling;
    (e ? i.matches(e) && t.push(i) : t.push(i), (s = i));
  }
  return t;
}
function Qt(s, e) {
  return Ye().getComputedStyle(s, null).getPropertyValue(e);
}
function Pn(s) {
  let e = s,
    t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function Eo(s, e) {
  const t = [];
  let i = s.parentElement;
  for (; i; )
    (e ? i.matches(e) && t.push(i) : t.push(i), (i = i.parentElement));
  return t;
}
function il(s, e) {
  function t(i) {
    i.target === s && (e.call(s, i), s.removeEventListener("transitionend", t));
  }
  e && s.addEventListener("transitionend", t);
}
function Dr(s, e, t) {
  const i = Ye();
  return (
    s[e === "width" ? "offsetWidth" : "offsetHeight"] +
    parseFloat(
      i
        .getComputedStyle(s, null)
        .getPropertyValue(e === "width" ? "margin-right" : "margin-top")
    ) +
    parseFloat(
      i
        .getComputedStyle(s, null)
        .getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")
    )
  );
}
function je(s) {
  return (Array.isArray(s) ? s : [s]).filter((e) => !!e);
}
let ar;
function nl() {
  const s = Ye(),
    e = ct();
  return {
    smoothScroll:
      e.documentElement &&
      e.documentElement.style &&
      "scrollBehavior" in e.documentElement.style,
    touch: !!(
      "ontouchstart" in s ||
      (s.DocumentTouch && e instanceof s.DocumentTouch)
    ),
  };
}
function To() {
  return (ar || (ar = nl()), ar);
}
let lr;
function rl(s) {
  let { userAgent: e } = s === void 0 ? {} : s;
  const t = To(),
    i = Ye(),
    n = i.navigator.platform,
    o = e || i.navigator.userAgent,
    l = {
      ios: !1,
      android: !1,
    },
    c = i.screen.width,
    u = i.screen.height,
    p = o.match(/(Android);?[\s\/]+([\d.]+)?/);
  let h = o.match(/(iPad).*OS\s([\d_]+)/);
  const m = o.match(/(iPod)(.*OS\s([\d_]+))?/),
    b = !h && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    w = n === "Win32";
  let S = n === "MacIntel";
  const E = [
    "1024x1366",
    "1366x1024",
    "834x1194",
    "1194x834",
    "834x1112",
    "1112x834",
    "768x1024",
    "1024x768",
    "820x1180",
    "1180x820",
    "810x1080",
    "1080x810",
  ];
  return (
    !h &&
      S &&
      t.touch &&
      E.indexOf(`${c}x${u}`) >= 0 &&
      ((h = o.match(/(Version)\/([\d.]+)/)),
      h || (h = [0, 1, "13_0_0"]),
      (S = !1)),
    p && !w && ((l.os = "android"), (l.android = !0)),
    (h || b || m) && ((l.os = "ios"), (l.ios = !0)),
    l
  );
}
function Co(s) {
  return (s === void 0 && (s = {}), lr || (lr = rl(s)), lr);
}
let cr;
function sl() {
  const s = Ye(),
    e = Co();
  let t = !1;
  function i() {
    const c = s.navigator.userAgent.toLowerCase();
    return (
      c.indexOf("safari") >= 0 &&
      c.indexOf("chrome") < 0 &&
      c.indexOf("android") < 0
    );
  }
  if (i()) {
    const c = String(s.navigator.userAgent);
    if (c.includes("Version/")) {
      const [u, p] = c
        .split("Version/")[1]
        .split(" ")[0]
        .split(".")
        .map((h) => Number(h));
      t = u < 16 || (u === 16 && p < 2);
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      s.navigator.userAgent
    ),
    o = i(),
    l = o || (n && e.ios);
  return {
    isSafari: t || o,
    needPerspectiveFix: t,
    need3dFix: l,
    isWebView: n,
  };
}
function ol() {
  return (cr || (cr = sl()), cr);
}
function al(s) {
  let { swiper: e, on: t, emit: i } = s;
  const n = Ye();
  let o = null,
    l = null;
  const c = () => {
      !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
    },
    u = () => {
      !e ||
        e.destroyed ||
        !e.initialized ||
        ((o = new ResizeObserver((m) => {
          l = n.requestAnimationFrame(() => {
            const { width: b, height: w } = e;
            let S = b,
              E = w;
            (m.forEach((P) => {
              let { contentBoxSize: T, contentRect: A, target: O } = P;
              (O && O !== e.el) ||
                ((S = A ? A.width : (T[0] || T).inlineSize),
                (E = A ? A.height : (T[0] || T).blockSize));
            }),
              (S !== b || E !== w) && c());
          });
        })),
        o.observe(e.el));
    },
    p = () => {
      (l && n.cancelAnimationFrame(l),
        o && o.unobserve && e.el && (o.unobserve(e.el), (o = null)));
    },
    h = () => {
      !e || e.destroyed || !e.initialized || i("orientationchange");
    };
  (t("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      u();
      return;
    }
    (n.addEventListener("resize", c),
      n.addEventListener("orientationchange", h));
  }),
    t("destroy", () => {
      (p(),
        n.removeEventListener("resize", c),
        n.removeEventListener("orientationchange", h));
    }));
}
function ll(s) {
  let { swiper: e, extendParams: t, on: i, emit: n } = s;
  const o = [],
    l = Ye(),
    c = function (h, m) {
      m === void 0 && (m = {});
      const b = l.MutationObserver || l.WebkitMutationObserver,
        w = new b((S) => {
          if (e.__preventObserver__) return;
          if (S.length === 1) {
            n("observerUpdate", S[0]);
            return;
          }
          const E = function () {
            n("observerUpdate", S[0]);
          };
          l.requestAnimationFrame
            ? l.requestAnimationFrame(E)
            : l.setTimeout(E, 0);
        });
      (w.observe(h, {
        attributes: typeof m.attributes > "u" ? !0 : m.attributes,
        childList: e.isElement || (typeof m.childList > "u" ? !0 : m).childList,
        characterData: typeof m.characterData > "u" ? !0 : m.characterData,
      }),
        o.push(w));
    },
    u = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const h = Eo(e.hostEl);
          for (let m = 0; m < h.length; m += 1) c(h[m]);
        }
        (c(e.hostEl, {
          childList: e.params.observeSlideChildren,
        }),
          c(e.wrapperEl, {
            attributes: !1,
          }));
      }
    },
    p = () => {
      (o.forEach((h) => {
        h.disconnect();
      }),
        o.splice(0, o.length));
    };
  (t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1,
  }),
    i("init", u),
    i("destroy", p));
}
var cl = {
  on(s, e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const n = t ? "unshift" : "push";
    return (
      s.split(" ").forEach((o) => {
        (i.eventsListeners[o] || (i.eventsListeners[o] = []),
          i.eventsListeners[o][n](e));
      }),
      i
    );
  },
  once(s, e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    function n() {
      (i.off(s, n), n.__emitterProxy && delete n.__emitterProxy);
      for (var o = arguments.length, l = new Array(o), c = 0; c < o; c++)
        l[c] = arguments[c];
      e.apply(i, l);
    }
    return ((n.__emitterProxy = e), i.on(s, n, t));
  },
  onAny(s, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof s != "function") return t;
    const i = e ? "unshift" : "push";
    return (
      t.eventsAnyListeners.indexOf(s) < 0 && t.eventsAnyListeners[i](s),
      t
    );
  },
  offAny(s) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const t = e.eventsAnyListeners.indexOf(s);
    return (t >= 0 && e.eventsAnyListeners.splice(t, 1), e);
  },
  off(s, e) {
    const t = this;
    return (
      !t.eventsListeners ||
        t.destroyed ||
        !t.eventsListeners ||
        s.split(" ").forEach((i) => {
          typeof e > "u"
            ? (t.eventsListeners[i] = [])
            : t.eventsListeners[i] &&
              t.eventsListeners[i].forEach((n, o) => {
                (n === e || (n.__emitterProxy && n.__emitterProxy === e)) &&
                  t.eventsListeners[i].splice(o, 1);
              });
        }),
      t
    );
  },
  emit() {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
    let e, t, i;
    for (var n = arguments.length, o = new Array(n), l = 0; l < n; l++)
      o[l] = arguments[l];
    return (
      typeof o[0] == "string" || Array.isArray(o[0])
        ? ((e = o[0]), (t = o.slice(1, o.length)), (i = s))
        : ((e = o[0].events), (t = o[0].data), (i = o[0].context || s)),
      t.unshift(i),
      (Array.isArray(e) ? e : e.split(" ")).forEach((u) => {
        (s.eventsAnyListeners &&
          s.eventsAnyListeners.length &&
          s.eventsAnyListeners.forEach((p) => {
            p.apply(i, [u, ...t]);
          }),
          s.eventsListeners &&
            s.eventsListeners[u] &&
            s.eventsListeners[u].forEach((p) => {
              p.apply(i, t);
            }));
      }),
      s
    );
  },
};
function ul() {
  const s = this;
  let e, t;
  const i = s.el;
  (typeof s.params.width < "u" && s.params.width !== null
    ? (e = s.params.width)
    : (e = i.clientWidth),
    typeof s.params.height < "u" && s.params.height !== null
      ? (t = s.params.height)
      : (t = i.clientHeight),
    !((e === 0 && s.isHorizontal()) || (t === 0 && s.isVertical())) &&
      ((e =
        e -
        parseInt(Qt(i, "padding-left") || 0, 10) -
        parseInt(Qt(i, "padding-right") || 0, 10)),
      (t =
        t -
        parseInt(Qt(i, "padding-top") || 0, 10) -
        parseInt(Qt(i, "padding-bottom") || 0, 10)),
      Number.isNaN(e) && (e = 0),
      Number.isNaN(t) && (t = 0),
      Object.assign(s, {
        width: e,
        height: t,
        size: s.isHorizontal() ? e : t,
      })));
}
function dl() {
  const s = this;
  function e(W, ie) {
    return parseFloat(W.getPropertyValue(s.getDirectionLabel(ie)) || 0);
  }
  const t = s.params,
    { wrapperEl: i, slidesEl: n, size: o, rtlTranslate: l, wrongRTL: c } = s,
    u = s.virtual && t.virtual.enabled,
    p = u ? s.virtual.slides.length : s.slides.length,
    h = Tt(n, `.${s.params.slideClass}, swiper-slide`),
    m = u ? s.virtual.slides.length : h.length;
  let b = [];
  const w = [],
    S = [];
  let E = t.slidesOffsetBefore;
  typeof E == "function" && (E = t.slidesOffsetBefore.call(s));
  let P = t.slidesOffsetAfter;
  typeof P == "function" && (P = t.slidesOffsetAfter.call(s));
  const T = s.snapGrid.length,
    A = s.slidesGrid.length;
  let O = t.spaceBetween,
    D = -E,
    _ = 0,
    X = 0;
  if (typeof o > "u") return;
  (typeof O == "string" && O.indexOf("%") >= 0
    ? (O = (parseFloat(O.replace("%", "")) / 100) * o)
    : typeof O == "string" && (O = parseFloat(O)),
    (s.virtualSize = -O),
    h.forEach((W) => {
      (l ? (W.style.marginLeft = "") : (W.style.marginRight = ""),
        (W.style.marginBottom = ""),
        (W.style.marginTop = ""));
    }),
    t.centeredSlides &&
      t.cssMode &&
      (an(i, "--swiper-centered-offset-before", ""),
      an(i, "--swiper-centered-offset-after", "")));
  const f = t.grid && t.grid.rows > 1 && s.grid;
  f ? s.grid.initSlides(h) : s.grid && s.grid.unsetSlides();
  let J;
  const G =
    t.slidesPerView === "auto" &&
    t.breakpoints &&
    Object.keys(t.breakpoints).filter(
      (W) => typeof t.breakpoints[W].slidesPerView < "u"
    ).length > 0;
  for (let W = 0; W < m; W += 1) {
    J = 0;
    let ie;
    if (
      (h[W] && (ie = h[W]),
      f && s.grid.updateSlide(W, ie, h),
      !(h[W] && Qt(ie, "display") === "none"))
    ) {
      if (t.slidesPerView === "auto") {
        G && (h[W].style[s.getDirectionLabel("width")] = "");
        const H = getComputedStyle(ie),
          R = ie.style.transform,
          V = ie.style.webkitTransform;
        if (
          (R && (ie.style.transform = "none"),
          V && (ie.style.webkitTransform = "none"),
          t.roundLengths)
        )
          J = s.isHorizontal() ? Dr(ie, "width") : Dr(ie, "height");
        else {
          const Q = e(H, "width"),
            ce = e(H, "padding-left"),
            Ce = e(H, "padding-right"),
            Y = e(H, "margin-left"),
            U = e(H, "margin-right"),
            le = H.getPropertyValue("box-sizing");
          if (le && le === "border-box") J = Q + Y + U;
          else {
            const { clientWidth: Te, offsetWidth: Pe } = ie;
            J = Q + ce + Ce + Y + U + (Pe - Te);
          }
        }
        (R && (ie.style.transform = R),
          V && (ie.style.webkitTransform = V),
          t.roundLengths && (J = Math.floor(J)));
      } else
        ((J = (o - (t.slidesPerView - 1) * O) / t.slidesPerView),
          t.roundLengths && (J = Math.floor(J)),
          h[W] && (h[W].style[s.getDirectionLabel("width")] = `${J}px`));
      (h[W] && (h[W].swiperSlideSize = J),
        S.push(J),
        t.centeredSlides
          ? ((D = D + J / 2 + _ / 2 + O),
            _ === 0 && W !== 0 && (D = D - o / 2 - O),
            W === 0 && (D = D - o / 2 - O),
            Math.abs(D) < 1 / 1e3 && (D = 0),
            t.roundLengths && (D = Math.floor(D)),
            X % t.slidesPerGroup === 0 && b.push(D),
            w.push(D))
          : (t.roundLengths && (D = Math.floor(D)),
            (X - Math.min(s.params.slidesPerGroupSkip, X)) %
              s.params.slidesPerGroup ===
              0 && b.push(D),
            w.push(D),
            (D = D + J + O)),
        (s.virtualSize += J + O),
        (_ = J),
        (X += 1));
    }
  }
  if (
    ((s.virtualSize = Math.max(s.virtualSize, o) + P),
    l &&
      c &&
      (t.effect === "slide" || t.effect === "coverflow") &&
      (i.style.width = `${s.virtualSize + O}px`),
    t.setWrapperSize &&
      (i.style[s.getDirectionLabel("width")] = `${s.virtualSize + O}px`),
    f && s.grid.updateWrapperSize(J, b),
    !t.centeredSlides)
  ) {
    const W = [];
    for (let ie = 0; ie < b.length; ie += 1) {
      let H = b[ie];
      (t.roundLengths && (H = Math.floor(H)),
        b[ie] <= s.virtualSize - o && W.push(H));
    }
    ((b = W),
      Math.floor(s.virtualSize - o) - Math.floor(b[b.length - 1]) > 1 &&
        b.push(s.virtualSize - o));
  }
  if (u && t.loop) {
    const W = S[0] + O;
    if (t.slidesPerGroup > 1) {
      const ie = Math.ceil(
          (s.virtual.slidesBefore + s.virtual.slidesAfter) / t.slidesPerGroup
        ),
        H = W * t.slidesPerGroup;
      for (let R = 0; R < ie; R += 1) b.push(b[b.length - 1] + H);
    }
    for (
      let ie = 0;
      ie < s.virtual.slidesBefore + s.virtual.slidesAfter;
      ie += 1
    )
      (t.slidesPerGroup === 1 && b.push(b[b.length - 1] + W),
        w.push(w[w.length - 1] + W),
        (s.virtualSize += W));
  }
  if ((b.length === 0 && (b = [0]), O !== 0)) {
    const W =
      s.isHorizontal() && l ? "marginLeft" : s.getDirectionLabel("marginRight");
    h.filter((ie, H) =>
      !t.cssMode || t.loop ? !0 : H !== h.length - 1
    ).forEach((ie) => {
      ie.style[W] = `${O}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let W = 0;
    (S.forEach((H) => {
      W += H + (O || 0);
    }),
      (W -= O));
    const ie = W > o ? W - o : 0;
    b = b.map((H) => (H <= 0 ? -E : H > ie ? ie + P : H));
  }
  if (t.centerInsufficientSlides) {
    let W = 0;
    (S.forEach((H) => {
      W += H + (O || 0);
    }),
      (W -= O));
    const ie = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0);
    if (W + ie < o) {
      const H = (o - W - ie) / 2;
      (b.forEach((R, V) => {
        b[V] = R - H;
      }),
        w.forEach((R, V) => {
          w[V] = R + H;
        }));
    }
  }
  if (
    (Object.assign(s, {
      slides: h,
      snapGrid: b,
      slidesGrid: w,
      slidesSizesGrid: S,
    }),
    t.centeredSlides && t.cssMode && !t.centeredSlidesBounds)
  ) {
    (an(i, "--swiper-centered-offset-before", `${-b[0]}px`),
      an(
        i,
        "--swiper-centered-offset-after",
        `${s.size / 2 - S[S.length - 1] / 2}px`
      ));
    const W = -s.snapGrid[0],
      ie = -s.slidesGrid[0];
    ((s.snapGrid = s.snapGrid.map((H) => H + W)),
      (s.slidesGrid = s.slidesGrid.map((H) => H + ie)));
  }
  if (
    (m !== p && s.emit("slidesLengthChange"),
    b.length !== T &&
      (s.params.watchOverflow && s.checkOverflow(),
      s.emit("snapGridLengthChange")),
    w.length !== A && s.emit("slidesGridLengthChange"),
    t.watchSlidesProgress && s.updateSlidesOffset(),
    s.emit("slidesUpdated"),
    !u && !t.cssMode && (t.effect === "slide" || t.effect === "fade"))
  ) {
    const W = `${t.containerModifierClass}backface-hidden`,
      ie = s.el.classList.contains(W);
    m <= t.maxBackfaceHiddenSlides
      ? ie || s.el.classList.add(W)
      : ie && s.el.classList.remove(W);
  }
}
function fl(s) {
  const e = this,
    t = [],
    i = e.virtual && e.params.virtual.enabled;
  let n = 0,
    o;
  typeof s == "number"
    ? e.setTransition(s)
    : s === !0 && e.setTransition(e.params.speed);
  const l = (c) => (i ? e.slides[e.getSlideIndexByData(c)] : e.slides[c]);
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((c) => {
        t.push(c);
      });
    else
      for (o = 0; o < Math.ceil(e.params.slidesPerView); o += 1) {
        const c = e.activeIndex + o;
        if (c > e.slides.length && !i) break;
        t.push(l(c));
      }
  else t.push(l(e.activeIndex));
  for (o = 0; o < t.length; o += 1)
    if (typeof t[o] < "u") {
      const c = t[o].offsetHeight;
      n = c > n ? c : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function hl() {
  const s = this,
    e = s.slides,
    t = s.isElement
      ? s.isHorizontal()
        ? s.wrapperEl.offsetLeft
        : s.wrapperEl.offsetTop
      : 0;
  for (let i = 0; i < e.length; i += 1)
    e[i].swiperSlideOffset =
      (s.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop) -
      t -
      s.cssOverflowAdjustment();
}
const Cs = (s, e, t) => {
  e && !s.classList.contains(t)
    ? s.classList.add(t)
    : !e && s.classList.contains(t) && s.classList.remove(t);
};
function pl(s) {
  s === void 0 && (s = (this && this.translate) || 0);
  const e = this,
    t = e.params,
    { slides: i, rtlTranslate: n, snapGrid: o } = e;
  if (i.length === 0) return;
  typeof i[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let l = -s;
  (n && (l = s), (e.visibleSlidesIndexes = []), (e.visibleSlides = []));
  let c = t.spaceBetween;
  typeof c == "string" && c.indexOf("%") >= 0
    ? (c = (parseFloat(c.replace("%", "")) / 100) * e.size)
    : typeof c == "string" && (c = parseFloat(c));
  for (let u = 0; u < i.length; u += 1) {
    const p = i[u];
    let h = p.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (h -= i[0].swiperSlideOffset);
    const m =
        (l + (t.centeredSlides ? e.minTranslate() : 0) - h) /
        (p.swiperSlideSize + c),
      b =
        (l - o[0] + (t.centeredSlides ? e.minTranslate() : 0) - h) /
        (p.swiperSlideSize + c),
      w = -(l - h),
      S = w + e.slidesSizesGrid[u],
      E = w >= 0 && w <= e.size - e.slidesSizesGrid[u],
      P =
        (w >= 0 && w < e.size - 1) ||
        (S > 1 && S <= e.size) ||
        (w <= 0 && S >= e.size);
    (P && (e.visibleSlides.push(p), e.visibleSlidesIndexes.push(u)),
      Cs(p, P, t.slideVisibleClass),
      Cs(p, E, t.slideFullyVisibleClass),
      (p.progress = n ? -m : m),
      (p.originalProgress = n ? -b : b));
  }
}
function gl(s) {
  const e = this;
  if (typeof s > "u") {
    const h = e.rtlTranslate ? -1 : 1;
    s = (e && e.translate && e.translate * h) || 0;
  }
  const t = e.params,
    i = e.maxTranslate() - e.minTranslate();
  let { progress: n, isBeginning: o, isEnd: l, progressLoop: c } = e;
  const u = o,
    p = l;
  if (i === 0) ((n = 0), (o = !0), (l = !0));
  else {
    n = (s - e.minTranslate()) / i;
    const h = Math.abs(s - e.minTranslate()) < 1,
      m = Math.abs(s - e.maxTranslate()) < 1;
    ((o = h || n <= 0), (l = m || n >= 1), h && (n = 0), m && (n = 1));
  }
  if (t.loop) {
    const h = e.getSlideIndexByData(0),
      m = e.getSlideIndexByData(e.slides.length - 1),
      b = e.slidesGrid[h],
      w = e.slidesGrid[m],
      S = e.slidesGrid[e.slidesGrid.length - 1],
      E = Math.abs(s);
    (E >= b ? (c = (E - b) / S) : (c = (E + S - w) / S), c > 1 && (c -= 1));
  }
  (Object.assign(e, {
    progress: n,
    progressLoop: c,
    isBeginning: o,
    isEnd: l,
  }),
    (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) &&
      e.updateSlidesProgress(s),
    o && !u && e.emit("reachBeginning toEdge"),
    l && !p && e.emit("reachEnd toEdge"),
    ((u && !o) || (p && !l)) && e.emit("fromEdge"),
    e.emit("progress", n));
}
const ur = (s, e, t) => {
  e && !s.classList.contains(t)
    ? s.classList.add(t)
    : !e && s.classList.contains(t) && s.classList.remove(t);
};
function ml() {
  const s = this,
    { slides: e, params: t, slidesEl: i, activeIndex: n } = s,
    o = s.virtual && t.virtual.enabled,
    l = s.grid && t.grid && t.grid.rows > 1,
    c = (m) => Tt(i, `.${t.slideClass}${m}, swiper-slide${m}`)[0];
  let u, p, h;
  if (o)
    if (t.loop) {
      let m = n - s.virtual.slidesBefore;
      (m < 0 && (m = s.virtual.slides.length + m),
        m >= s.virtual.slides.length && (m -= s.virtual.slides.length),
        (u = c(`[data-swiper-slide-index="${m}"]`)));
    } else u = c(`[data-swiper-slide-index="${n}"]`);
  else
    l
      ? ((u = e.find((m) => m.column === n)),
        (h = e.find((m) => m.column === n + 1)),
        (p = e.find((m) => m.column === n - 1)))
      : (u = e[n]);
  (u &&
    (l ||
      ((h = tl(u, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !h && (h = e[0]),
      (p = el(u, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !p === 0 && (p = e[e.length - 1]))),
    e.forEach((m) => {
      (ur(m, m === u, t.slideActiveClass),
        ur(m, m === h, t.slideNextClass),
        ur(m, m === p, t.slidePrevClass));
    }),
    s.emitSlidesClasses());
}
const xn = (s, e) => {
    if (!s || s.destroyed || !s.params) return;
    const t = () => (s.isElement ? "swiper-slide" : `.${s.params.slideClass}`),
      i = e.closest(t());
    if (i) {
      let n = i.querySelector(`.${s.params.lazyPreloaderClass}`);
      (!n &&
        s.isElement &&
        (i.shadowRoot
          ? (n = i.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`))
          : requestAnimationFrame(() => {
              i.shadowRoot &&
                ((n = i.shadowRoot.querySelector(
                  `.${s.params.lazyPreloaderClass}`
                )),
                n && n.remove());
            })),
        n && n.remove());
    }
  },
  dr = (s, e) => {
    if (!s.slides[e]) return;
    const t = s.slides[e].querySelector('[loading="lazy"]');
    t && t.removeAttribute("loading");
  },
  zr = (s) => {
    if (!s || s.destroyed || !s.params) return;
    let e = s.params.lazyPreloadPrevNext;
    const t = s.slides.length;
    if (!t || !e || e < 0) return;
    e = Math.min(e, t);
    const i =
        s.params.slidesPerView === "auto"
          ? s.slidesPerViewDynamic()
          : Math.ceil(s.params.slidesPerView),
      n = s.activeIndex;
    if (s.params.grid && s.params.grid.rows > 1) {
      const l = n,
        c = [l - e];
      (c.push(
        ...Array.from({
          length: e,
        }).map((u, p) => l + i + p)
      ),
        s.slides.forEach((u, p) => {
          c.includes(u.column) && dr(s, p);
        }));
      return;
    }
    const o = n + i - 1;
    if (s.params.rewind || s.params.loop)
      for (let l = n - e; l <= o + e; l += 1) {
        const c = ((l % t) + t) % t;
        (c < n || c > o) && dr(s, c);
      }
    else
      for (let l = Math.max(n - e, 0); l <= Math.min(o + e, t - 1); l += 1)
        l !== n && (l > o || l < n) && dr(s, l);
  };
function vl(s) {
  const { slidesGrid: e, params: t } = s,
    i = s.rtlTranslate ? s.translate : -s.translate;
  let n;
  for (let o = 0; o < e.length; o += 1)
    typeof e[o + 1] < "u"
      ? i >= e[o] && i < e[o + 1] - (e[o + 1] - e[o]) / 2
        ? (n = o)
        : i >= e[o] && i < e[o + 1] && (n = o + 1)
      : i >= e[o] && (n = o);
  return (t.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n);
}
function bl(s) {
  const e = this,
    t = e.rtlTranslate ? e.translate : -e.translate,
    { snapGrid: i, params: n, activeIndex: o, realIndex: l, snapIndex: c } = e;
  let u = s,
    p;
  const h = (w) => {
    let S = w - e.virtual.slidesBefore;
    return (
      S < 0 && (S = e.virtual.slides.length + S),
      S >= e.virtual.slides.length && (S -= e.virtual.slides.length),
      S
    );
  };
  if ((typeof u > "u" && (u = vl(e)), i.indexOf(t) >= 0)) p = i.indexOf(t);
  else {
    const w = Math.min(n.slidesPerGroupSkip, u);
    p = w + Math.floor((u - w) / n.slidesPerGroup);
  }
  if ((p >= i.length && (p = i.length - 1), u === o && !e.params.loop)) {
    p !== c && ((e.snapIndex = p), e.emit("snapIndexChange"));
    return;
  }
  if (u === o && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = h(u);
    return;
  }
  const m = e.grid && n.grid && n.grid.rows > 1;
  let b;
  if (e.virtual && n.virtual.enabled && n.loop) b = h(u);
  else if (m) {
    const w = e.slides.find((E) => E.column === u);
    let S = parseInt(w.getAttribute("data-swiper-slide-index"), 10);
    (Number.isNaN(S) && (S = Math.max(e.slides.indexOf(w), 0)),
      (b = Math.floor(S / n.grid.rows)));
  } else if (e.slides[u]) {
    const w = e.slides[u].getAttribute("data-swiper-slide-index");
    w ? (b = parseInt(w, 10)) : (b = u);
  } else b = u;
  (Object.assign(e, {
    previousSnapIndex: c,
    snapIndex: p,
    previousRealIndex: l,
    realIndex: b,
    previousIndex: o,
    activeIndex: u,
  }),
    e.initialized && zr(e),
    e.emit("activeIndexChange"),
    e.emit("snapIndexChange"),
    (e.initialized || e.params.runCallbacksOnInit) &&
      (l !== b && e.emit("realIndexChange"), e.emit("slideChange")));
}
function yl(s, e) {
  const t = this,
    i = t.params;
  let n = s.closest(`.${i.slideClass}, swiper-slide`);
  !n &&
    t.isElement &&
    e &&
    e.length > 1 &&
    e.includes(s) &&
    [...e.slice(e.indexOf(s) + 1, e.length)].forEach((c) => {
      !n && c.matches && c.matches(`.${i.slideClass}, swiper-slide`) && (n = c);
    });
  let o = !1,
    l;
  if (n) {
    for (let c = 0; c < t.slides.length; c += 1)
      if (t.slides[c] === n) {
        ((o = !0), (l = c));
        break;
      }
  }
  if (n && o)
    ((t.clickedSlide = n),
      t.virtual && t.params.virtual.enabled
        ? (t.clickedIndex = parseInt(
            n.getAttribute("data-swiper-slide-index"),
            10
          ))
        : (t.clickedIndex = l));
  else {
    ((t.clickedSlide = void 0), (t.clickedIndex = void 0));
    return;
  }
  i.slideToClickedSlide &&
    t.clickedIndex !== void 0 &&
    t.clickedIndex !== t.activeIndex &&
    t.slideToClickedSlide();
}
var wl = {
  updateSize: ul,
  updateSlides: dl,
  updateAutoHeight: fl,
  updateSlidesOffset: hl,
  updateSlidesProgress: pl,
  updateProgress: gl,
  updateSlidesClasses: ml,
  updateActiveIndex: bl,
  updateClickedSlide: yl,
};
function Sl(s) {
  s === void 0 && (s = this.isHorizontal() ? "x" : "y");
  const e = this,
    { params: t, rtlTranslate: i, translate: n, wrapperEl: o } = e;
  if (t.virtualTranslate) return i ? -n : n;
  if (t.cssMode) return n;
  let l = Ua(o, s);
  return ((l += e.cssOverflowAdjustment()), i && (l = -l), l || 0);
}
function xl(s, e) {
  const t = this,
    { rtlTranslate: i, params: n, wrapperEl: o, progress: l } = t;
  let c = 0,
    u = 0;
  const p = 0;
  (t.isHorizontal() ? (c = i ? -s : s) : (u = s),
    n.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
    (t.previousTranslate = t.translate),
    (t.translate = t.isHorizontal() ? c : u),
    n.cssMode
      ? (o[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal()
          ? -c
          : -u)
      : n.virtualTranslate ||
        (t.isHorizontal()
          ? (c -= t.cssOverflowAdjustment())
          : (u -= t.cssOverflowAdjustment()),
        (o.style.transform = `translate3d(${c}px, ${u}px, ${p}px)`)));
  let h;
  const m = t.maxTranslate() - t.minTranslate();
  (m === 0 ? (h = 0) : (h = (s - t.minTranslate()) / m),
    h !== l && t.updateProgress(s),
    t.emit("setTranslate", t.translate, e));
}
function El() {
  return -this.snapGrid[0];
}
function Tl() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Cl(s, e, t, i, n) {
  (s === void 0 && (s = 0),
    e === void 0 && (e = this.params.speed),
    t === void 0 && (t = !0),
    i === void 0 && (i = !0));
  const o = this,
    { params: l, wrapperEl: c } = o;
  if (o.animating && l.preventInteractionOnTransition) return !1;
  const u = o.minTranslate(),
    p = o.maxTranslate();
  let h;
  if (
    (i && s > u ? (h = u) : i && s < p ? (h = p) : (h = s),
    o.updateProgress(h),
    l.cssMode)
  ) {
    const m = o.isHorizontal();
    if (e === 0) c[m ? "scrollLeft" : "scrollTop"] = -h;
    else {
      if (!o.support.smoothScroll)
        return (
          So({
            swiper: o,
            targetPosition: -h,
            side: m ? "left" : "top",
          }),
          !0
        );
      c.scrollTo({
        [m ? "left" : "top"]: -h,
        behavior: "smooth",
      });
    }
    return !0;
  }
  return (
    e === 0
      ? (o.setTransition(0),
        o.setTranslate(h),
        t && (o.emit("beforeTransitionStart", e, n), o.emit("transitionEnd")))
      : (o.setTransition(e),
        o.setTranslate(h),
        t && (o.emit("beforeTransitionStart", e, n), o.emit("transitionStart")),
        o.animating ||
          ((o.animating = !0),
          o.onTranslateToWrapperTransitionEnd ||
            (o.onTranslateToWrapperTransitionEnd = function (b) {
              !o ||
                o.destroyed ||
                (b.target === this &&
                  (o.wrapperEl.removeEventListener(
                    "transitionend",
                    o.onTranslateToWrapperTransitionEnd
                  ),
                  (o.onTranslateToWrapperTransitionEnd = null),
                  delete o.onTranslateToWrapperTransitionEnd,
                  (o.animating = !1),
                  t && o.emit("transitionEnd")));
            }),
          o.wrapperEl.addEventListener(
            "transitionend",
            o.onTranslateToWrapperTransitionEnd
          ))),
    !0
  );
}
var Al = {
  getTranslate: Sl,
  setTranslate: xl,
  minTranslate: El,
  maxTranslate: Tl,
  translateTo: Cl,
};
function Pl(s, e) {
  const t = this;
  (t.params.cssMode ||
    ((t.wrapperEl.style.transitionDuration = `${s}ms`),
    (t.wrapperEl.style.transitionDelay = s === 0 ? "0ms" : "")),
    t.emit("setTransition", s, e));
}
function Ao(s) {
  let { swiper: e, runCallbacks: t, direction: i, step: n } = s;
  const { activeIndex: o, previousIndex: l } = e;
  let c = i;
  if (
    (c || (o > l ? (c = "next") : o < l ? (c = "prev") : (c = "reset")),
    e.emit(`transition${n}`),
    t && o !== l)
  ) {
    if (c === "reset") {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    (e.emit(`slideChangeTransition${n}`),
      c === "next"
        ? e.emit(`slideNextTransition${n}`)
        : e.emit(`slidePrevTransition${n}`));
  }
}
function Ll(s, e) {
  s === void 0 && (s = !0);
  const t = this,
    { params: i } = t;
  i.cssMode ||
    (i.autoHeight && t.updateAutoHeight(),
    Ao({
      swiper: t,
      runCallbacks: s,
      direction: e,
      step: "Start",
    }));
}
function Ml(s, e) {
  s === void 0 && (s = !0);
  const t = this,
    { params: i } = t;
  ((t.animating = !1),
    !i.cssMode &&
      (t.setTransition(0),
      Ao({
        swiper: t,
        runCallbacks: s,
        direction: e,
        step: "End",
      })));
}
var Ol = {
  setTransition: Pl,
  transitionStart: Ll,
  transitionEnd: Ml,
};
function Il(s, e, t, i, n) {
  (s === void 0 && (s = 0),
    t === void 0 && (t = !0),
    typeof s == "string" && (s = parseInt(s, 10)));
  const o = this;
  let l = s;
  l < 0 && (l = 0);
  const {
    params: c,
    snapGrid: u,
    slidesGrid: p,
    previousIndex: h,
    activeIndex: m,
    rtlTranslate: b,
    wrapperEl: w,
    enabled: S,
  } = o;
  if (
    (!S && !i && !n) ||
    o.destroyed ||
    (o.animating && c.preventInteractionOnTransition)
  )
    return !1;
  typeof e > "u" && (e = o.params.speed);
  const E = Math.min(o.params.slidesPerGroupSkip, l);
  let P = E + Math.floor((l - E) / o.params.slidesPerGroup);
  P >= u.length && (P = u.length - 1);
  const T = -u[P];
  if (c.normalizeSlideIndex)
    for (let _ = 0; _ < p.length; _ += 1) {
      const X = -Math.floor(T * 100),
        f = Math.floor(p[_] * 100),
        J = Math.floor(p[_ + 1] * 100);
      typeof p[_ + 1] < "u"
        ? X >= f && X < J - (J - f) / 2
          ? (l = _)
          : X >= f && X < J && (l = _ + 1)
        : X >= f && (l = _);
    }
  if (
    o.initialized &&
    l !== m &&
    ((!o.allowSlideNext &&
      (b
        ? T > o.translate && T > o.minTranslate()
        : T < o.translate && T < o.minTranslate())) ||
      (!o.allowSlidePrev &&
        T > o.translate &&
        T > o.maxTranslate() &&
        (m || 0) !== l))
  )
    return !1;
  (l !== (h || 0) && t && o.emit("beforeSlideChangeStart"),
    o.updateProgress(T));
  let A;
  l > m ? (A = "next") : l < m ? (A = "prev") : (A = "reset");
  const O = o.virtual && o.params.virtual.enabled;
  if (!(O && n) && ((b && -T === o.translate) || (!b && T === o.translate)))
    return (
      o.updateActiveIndex(l),
      c.autoHeight && o.updateAutoHeight(),
      o.updateSlidesClasses(),
      c.effect !== "slide" && o.setTranslate(T),
      A !== "reset" && (o.transitionStart(t, A), o.transitionEnd(t, A)),
      !1
    );
  if (c.cssMode) {
    const _ = o.isHorizontal(),
      X = b ? T : -T;
    if (e === 0)
      (O &&
        ((o.wrapperEl.style.scrollSnapType = "none"),
        (o._immediateVirtual = !0)),
        O && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0
          ? ((o._cssModeVirtualInitialSet = !0),
            requestAnimationFrame(() => {
              w[_ ? "scrollLeft" : "scrollTop"] = X;
            }))
          : (w[_ ? "scrollLeft" : "scrollTop"] = X),
        O &&
          requestAnimationFrame(() => {
            ((o.wrapperEl.style.scrollSnapType = ""),
              (o._immediateVirtual = !1));
          }));
    else {
      if (!o.support.smoothScroll)
        return (
          So({
            swiper: o,
            targetPosition: X,
            side: _ ? "left" : "top",
          }),
          !0
        );
      w.scrollTo({
        [_ ? "left" : "top"]: X,
        behavior: "smooth",
      });
    }
    return !0;
  }
  return (
    o.setTransition(e),
    o.setTranslate(T),
    o.updateActiveIndex(l),
    o.updateSlidesClasses(),
    o.emit("beforeTransitionStart", e, i),
    o.transitionStart(t, A),
    e === 0
      ? o.transitionEnd(t, A)
      : o.animating ||
        ((o.animating = !0),
        o.onSlideToWrapperTransitionEnd ||
          (o.onSlideToWrapperTransitionEnd = function (X) {
            !o ||
              o.destroyed ||
              (X.target === this &&
                (o.wrapperEl.removeEventListener(
                  "transitionend",
                  o.onSlideToWrapperTransitionEnd
                ),
                (o.onSlideToWrapperTransitionEnd = null),
                delete o.onSlideToWrapperTransitionEnd,
                o.transitionEnd(t, A)));
          }),
        o.wrapperEl.addEventListener(
          "transitionend",
          o.onSlideToWrapperTransitionEnd
        )),
    !0
  );
}
function kl(s, e, t, i) {
  (s === void 0 && (s = 0),
    t === void 0 && (t = !0),
    typeof s == "string" && (s = parseInt(s, 10)));
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  const o = n.grid && n.params.grid && n.params.grid.rows > 1;
  let l = s;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled) l = l + n.virtual.slidesBefore;
    else {
      let c;
      if (o) {
        const b = l * n.params.grid.rows;
        c = n.slides.find(
          (w) => w.getAttribute("data-swiper-slide-index") * 1 === b
        ).column;
      } else c = n.getSlideIndexByData(l);
      const u = o
          ? Math.ceil(n.slides.length / n.params.grid.rows)
          : n.slides.length,
        { centeredSlides: p } = n.params;
      let h = n.params.slidesPerView;
      h === "auto"
        ? (h = n.slidesPerViewDynamic())
        : ((h = Math.ceil(parseFloat(n.params.slidesPerView, 10))),
          p && h % 2 === 0 && (h = h + 1));
      let m = u - c < h;
      if (
        (p && (m = m || c < Math.ceil(h / 2)),
        i && p && n.params.slidesPerView !== "auto" && !o && (m = !1),
        m)
      ) {
        const b = p
          ? c < n.activeIndex
            ? "prev"
            : "next"
          : c - n.activeIndex - 1 < n.params.slidesPerView
            ? "next"
            : "prev";
        n.loopFix({
          direction: b,
          slideTo: !0,
          activeSlideIndex: b === "next" ? c + 1 : c - u + 1,
          slideRealIndex: b === "next" ? n.realIndex : void 0,
        });
      }
      if (o) {
        const b = l * n.params.grid.rows;
        l = n.slides.find(
          (w) => w.getAttribute("data-swiper-slide-index") * 1 === b
        ).column;
      } else l = n.getSlideIndexByData(l);
    }
  return (
    requestAnimationFrame(() => {
      n.slideTo(l, e, t, i);
    }),
    n
  );
}
function Dl(s, e, t) {
  e === void 0 && (e = !0);
  const i = this,
    { enabled: n, params: o, animating: l } = i;
  if (!n || i.destroyed) return i;
  typeof s > "u" && (s = i.params.speed);
  let c = o.slidesPerGroup;
  o.slidesPerView === "auto" &&
    o.slidesPerGroup === 1 &&
    o.slidesPerGroupAuto &&
    (c = Math.max(i.slidesPerViewDynamic("current", !0), 1));
  const u = i.activeIndex < o.slidesPerGroupSkip ? 1 : c,
    p = i.virtual && o.virtual.enabled;
  if (o.loop) {
    if (l && !p && o.loopPreventsSliding) return !1;
    if (
      (i.loopFix({
        direction: "next",
      }),
      (i._clientLeft = i.wrapperEl.clientLeft),
      i.activeIndex === i.slides.length - 1 && o.cssMode)
    )
      return (
        requestAnimationFrame(() => {
          i.slideTo(i.activeIndex + u, s, e, t);
        }),
        !0
      );
  }
  return o.rewind && i.isEnd
    ? i.slideTo(0, s, e, t)
    : i.slideTo(i.activeIndex + u, s, e, t);
}
function zl(s, e, t) {
  e === void 0 && (e = !0);
  const i = this,
    {
      params: n,
      snapGrid: o,
      slidesGrid: l,
      rtlTranslate: c,
      enabled: u,
      animating: p,
    } = i;
  if (!u || i.destroyed) return i;
  typeof s > "u" && (s = i.params.speed);
  const h = i.virtual && n.virtual.enabled;
  if (n.loop) {
    if (p && !h && n.loopPreventsSliding) return !1;
    (i.loopFix({
      direction: "prev",
    }),
      (i._clientLeft = i.wrapperEl.clientLeft));
  }
  const m = c ? i.translate : -i.translate;
  function b(T) {
    return T < 0 ? -Math.floor(Math.abs(T)) : Math.floor(T);
  }
  const w = b(m),
    S = o.map((T) => b(T));
  let E = o[S.indexOf(w) - 1];
  if (typeof E > "u" && n.cssMode) {
    let T;
    (o.forEach((A, O) => {
      w >= A && (T = O);
    }),
      typeof T < "u" && (E = o[T > 0 ? T - 1 : T]));
  }
  let P = 0;
  if (
    (typeof E < "u" &&
      ((P = l.indexOf(E)),
      P < 0 && (P = i.activeIndex - 1),
      n.slidesPerView === "auto" &&
        n.slidesPerGroup === 1 &&
        n.slidesPerGroupAuto &&
        ((P = P - i.slidesPerViewDynamic("previous", !0) + 1),
        (P = Math.max(P, 0)))),
    n.rewind && i.isBeginning)
  ) {
    const T =
      i.params.virtual && i.params.virtual.enabled && i.virtual
        ? i.virtual.slides.length - 1
        : i.slides.length - 1;
    return i.slideTo(T, s, e, t);
  } else if (n.loop && i.activeIndex === 0 && n.cssMode)
    return (
      requestAnimationFrame(() => {
        i.slideTo(P, s, e, t);
      }),
      !0
    );
  return i.slideTo(P, s, e, t);
}
function Rl(s, e, t) {
  e === void 0 && (e = !0);
  const i = this;
  if (!i.destroyed)
    return (
      typeof s > "u" && (s = i.params.speed),
      i.slideTo(i.activeIndex, s, e, t)
    );
}
function Fl(s, e, t, i) {
  (e === void 0 && (e = !0), i === void 0 && (i = 0.5));
  const n = this;
  if (n.destroyed) return;
  typeof s > "u" && (s = n.params.speed);
  let o = n.activeIndex;
  const l = Math.min(n.params.slidesPerGroupSkip, o),
    c = l + Math.floor((o - l) / n.params.slidesPerGroup),
    u = n.rtlTranslate ? n.translate : -n.translate;
  if (u >= n.snapGrid[c]) {
    const p = n.snapGrid[c],
      h = n.snapGrid[c + 1];
    u - p > (h - p) * i && (o += n.params.slidesPerGroup);
  } else {
    const p = n.snapGrid[c - 1],
      h = n.snapGrid[c];
    u - p <= (h - p) * i && (o -= n.params.slidesPerGroup);
  }
  return (
    (o = Math.max(o, 0)),
    (o = Math.min(o, n.slidesGrid.length - 1)),
    n.slideTo(o, s, e, t)
  );
}
function ql() {
  const s = this;
  if (s.destroyed) return;
  const { params: e, slidesEl: t } = s,
    i = e.slidesPerView === "auto" ? s.slidesPerViewDynamic() : e.slidesPerView;
  let n = s.clickedIndex,
    o;
  const l = s.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (s.animating) return;
    ((o = parseInt(s.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
      e.centeredSlides
        ? n < s.loopedSlides - i / 2 ||
          n > s.slides.length - s.loopedSlides + i / 2
          ? (s.loopFix(),
            (n = s.getSlideIndex(
              Tt(t, `${l}[data-swiper-slide-index="${o}"]`)[0]
            )),
            Tn(() => {
              s.slideTo(n);
            }))
          : s.slideTo(n)
        : n > s.slides.length - i
          ? (s.loopFix(),
            (n = s.getSlideIndex(
              Tt(t, `${l}[data-swiper-slide-index="${o}"]`)[0]
            )),
            Tn(() => {
              s.slideTo(n);
            }))
          : s.slideTo(n));
  } else s.slideTo(n);
}
var _l = {
  slideTo: Il,
  slideToLoop: kl,
  slideNext: Dl,
  slidePrev: zl,
  slideReset: Rl,
  slideToClosest: Fl,
  slideToClickedSlide: ql,
};
function Nl(s) {
  const e = this,
    { params: t, slidesEl: i } = e;
  if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
  const n = () => {
      Tt(i, `.${t.slideClass}, swiper-slide`).forEach((m, b) => {
        m.setAttribute("data-swiper-slide-index", b);
      });
    },
    o = e.grid && t.grid && t.grid.rows > 1,
    l = t.slidesPerGroup * (o ? t.grid.rows : 1),
    c = e.slides.length % l !== 0,
    u = o && e.slides.length % t.grid.rows !== 0,
    p = (h) => {
      for (let m = 0; m < h; m += 1) {
        const b = e.isElement
          ? Yi("swiper-slide", [t.slideBlankClass])
          : Yi("div", [t.slideClass, t.slideBlankClass]);
        e.slidesEl.append(b);
      }
    };
  if (c) {
    if (t.loopAddBlankSlides) {
      const h = l - (e.slides.length % l);
      (p(h), e.recalcSlides(), e.updateSlides());
    } else
      An(
        "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
      );
    n();
  } else if (u) {
    if (t.loopAddBlankSlides) {
      const h = t.grid.rows - (e.slides.length % t.grid.rows);
      (p(h), e.recalcSlides(), e.updateSlides());
    } else
      An(
        "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
      );
    n();
  } else n();
  e.loopFix({
    slideRealIndex: s,
    direction: t.centeredSlides ? void 0 : "next",
  });
}
function jl(s) {
  let {
    slideRealIndex: e,
    slideTo: t = !0,
    direction: i,
    setTranslate: n,
    activeSlideIndex: o,
    byController: l,
    byMousewheel: c,
  } = s === void 0 ? {} : s;
  const u = this;
  if (!u.params.loop) return;
  u.emit("beforeLoopFix");
  const {
      slides: p,
      allowSlidePrev: h,
      allowSlideNext: m,
      slidesEl: b,
      params: w,
    } = u,
    { centeredSlides: S } = w;
  if (
    ((u.allowSlidePrev = !0),
    (u.allowSlideNext = !0),
    u.virtual && w.virtual.enabled)
  ) {
    (t &&
      (!w.centeredSlides && u.snapIndex === 0
        ? u.slideTo(u.virtual.slides.length, 0, !1, !0)
        : w.centeredSlides && u.snapIndex < w.slidesPerView
          ? u.slideTo(u.virtual.slides.length + u.snapIndex, 0, !1, !0)
          : u.snapIndex === u.snapGrid.length - 1 &&
            u.slideTo(u.virtual.slidesBefore, 0, !1, !0)),
      (u.allowSlidePrev = h),
      (u.allowSlideNext = m),
      u.emit("loopFix"));
    return;
  }
  let E = w.slidesPerView;
  E === "auto"
    ? (E = u.slidesPerViewDynamic())
    : ((E = Math.ceil(parseFloat(w.slidesPerView, 10))),
      S && E % 2 === 0 && (E = E + 1));
  const P = w.slidesPerGroupAuto ? E : w.slidesPerGroup;
  let T = P;
  (T % P !== 0 && (T += P - (T % P)),
    (T += w.loopAdditionalSlides),
    (u.loopedSlides = T));
  const A = u.grid && w.grid && w.grid.rows > 1;
  p.length < E + T
    ? An(
        "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
      )
    : A &&
      w.grid.fill === "row" &&
      An(
        "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`"
      );
  const O = [],
    D = [];
  let _ = u.activeIndex;
  typeof o > "u"
    ? (o = u.getSlideIndex(
        p.find((R) => R.classList.contains(w.slideActiveClass))
      ))
    : (_ = o);
  const X = i === "next" || !i,
    f = i === "prev" || !i;
  let J = 0,
    G = 0;
  const W = A ? Math.ceil(p.length / w.grid.rows) : p.length,
    H = (A ? p[o].column : o) + (S && typeof n > "u" ? -E / 2 + 0.5 : 0);
  if (H < T) {
    J = Math.max(T - H, P);
    for (let R = 0; R < T - H; R += 1) {
      const V = R - Math.floor(R / W) * W;
      if (A) {
        const Q = W - V - 1;
        for (let ce = p.length - 1; ce >= 0; ce -= 1)
          p[ce].column === Q && O.push(ce);
      } else O.push(W - V - 1);
    }
  } else if (H + E > W - T) {
    G = Math.max(H - (W - T * 2), P);
    for (let R = 0; R < G; R += 1) {
      const V = R - Math.floor(R / W) * W;
      A
        ? p.forEach((Q, ce) => {
            Q.column === V && D.push(ce);
          })
        : D.push(V);
    }
  }
  if (
    ((u.__preventObserver__ = !0),
    requestAnimationFrame(() => {
      u.__preventObserver__ = !1;
    }),
    f &&
      O.forEach((R) => {
        ((p[R].swiperLoopMoveDOM = !0),
          b.prepend(p[R]),
          (p[R].swiperLoopMoveDOM = !1));
      }),
    X &&
      D.forEach((R) => {
        ((p[R].swiperLoopMoveDOM = !0),
          b.append(p[R]),
          (p[R].swiperLoopMoveDOM = !1));
      }),
    u.recalcSlides(),
    w.slidesPerView === "auto"
      ? u.updateSlides()
      : A &&
        ((O.length > 0 && f) || (D.length > 0 && X)) &&
        u.slides.forEach((R, V) => {
          u.grid.updateSlide(V, R, u.slides);
        }),
    w.watchSlidesProgress && u.updateSlidesOffset(),
    t)
  ) {
    if (O.length > 0 && f) {
      if (typeof e > "u") {
        const R = u.slidesGrid[_],
          Q = u.slidesGrid[_ + J] - R;
        c
          ? u.setTranslate(u.translate - Q)
          : (u.slideTo(_ + Math.ceil(J), 0, !1, !0),
            n &&
              ((u.touchEventsData.startTranslate =
                u.touchEventsData.startTranslate - Q),
              (u.touchEventsData.currentTranslate =
                u.touchEventsData.currentTranslate - Q)));
      } else if (n) {
        const R = A ? O.length / w.grid.rows : O.length;
        (u.slideTo(u.activeIndex + R, 0, !1, !0),
          (u.touchEventsData.currentTranslate = u.translate));
      }
    } else if (D.length > 0 && X)
      if (typeof e > "u") {
        const R = u.slidesGrid[_],
          Q = u.slidesGrid[_ - G] - R;
        c
          ? u.setTranslate(u.translate - Q)
          : (u.slideTo(_ - G, 0, !1, !0),
            n &&
              ((u.touchEventsData.startTranslate =
                u.touchEventsData.startTranslate - Q),
              (u.touchEventsData.currentTranslate =
                u.touchEventsData.currentTranslate - Q)));
      } else {
        const R = A ? D.length / w.grid.rows : D.length;
        u.slideTo(u.activeIndex - R, 0, !1, !0);
      }
  }
  if (
    ((u.allowSlidePrev = h),
    (u.allowSlideNext = m),
    u.controller && u.controller.control && !l)
  ) {
    const R = {
      slideRealIndex: e,
      direction: i,
      setTranslate: n,
      activeSlideIndex: o,
      byController: !0,
    };
    Array.isArray(u.controller.control)
      ? u.controller.control.forEach((V) => {
          !V.destroyed &&
            V.params.loop &&
            V.loopFix({
              ...R,
              slideTo: V.params.slidesPerView === w.slidesPerView ? t : !1,
            });
        })
      : u.controller.control instanceof u.constructor &&
        u.controller.control.params.loop &&
        u.controller.control.loopFix({
          ...R,
          slideTo:
            u.controller.control.params.slidesPerView === w.slidesPerView
              ? t
              : !1,
        });
  }
  u.emit("loopFix");
}
function Bl() {
  const s = this,
    { params: e, slidesEl: t } = s;
  if (!e.loop || (s.virtual && s.params.virtual.enabled)) return;
  s.recalcSlides();
  const i = [];
  (s.slides.forEach((n) => {
    const o =
      typeof n.swiperSlideIndex > "u"
        ? n.getAttribute("data-swiper-slide-index") * 1
        : n.swiperSlideIndex;
    i[o] = n;
  }),
    s.slides.forEach((n) => {
      n.removeAttribute("data-swiper-slide-index");
    }),
    i.forEach((n) => {
      t.append(n);
    }),
    s.recalcSlides(),
    s.slideTo(s.realIndex, 0));
}
var Hl = {
  loopCreate: Nl,
  loopFix: jl,
  loopDestroy: Bl,
};
function Vl(s) {
  const e = this;
  if (
    !e.params.simulateTouch ||
    (e.params.watchOverflow && e.isLocked) ||
    e.params.cssMode
  )
    return;
  const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  (e.isElement && (e.__preventObserver__ = !0),
    (t.style.cursor = "move"),
    (t.style.cursor = s ? "grabbing" : "grab"),
    e.isElement &&
      requestAnimationFrame(() => {
        e.__preventObserver__ = !1;
      }));
}
function $l() {
  const s = this;
  (s.params.watchOverflow && s.isLocked) ||
    s.params.cssMode ||
    (s.isElement && (s.__preventObserver__ = !0),
    (s[
      s.params.touchEventsTarget === "container" ? "el" : "wrapperEl"
    ].style.cursor = ""),
    s.isElement &&
      requestAnimationFrame(() => {
        s.__preventObserver__ = !1;
      }));
}
var Wl = {
  setGrabCursor: Vl,
  unsetGrabCursor: $l,
};
function Gl(s, e) {
  e === void 0 && (e = this);
  function t(i) {
    if (!i || i === ct() || i === Ye()) return null;
    i.assignedSlot && (i = i.assignedSlot);
    const n = i.closest(s);
    return !n && !i.getRootNode ? null : n || t(i.getRootNode().host);
  }
  return t(e);
}
function As(s, e, t) {
  const i = Ye(),
    { params: n } = s,
    o = n.edgeSwipeDetection,
    l = n.edgeSwipeThreshold;
  return o && (t <= l || t >= i.innerWidth - l)
    ? o === "prevent"
      ? (e.preventDefault(), !0)
      : !1
    : !0;
}
function Xl(s) {
  const e = this,
    t = ct();
  let i = s;
  i.originalEvent && (i = i.originalEvent);
  const n = e.touchEventsData;
  if (i.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== i.pointerId) return;
    n.pointerId = i.pointerId;
  } else
    i.type === "touchstart" &&
      i.targetTouches.length === 1 &&
      (n.touchId = i.targetTouches[0].identifier);
  if (i.type === "touchstart") {
    As(e, i, i.targetTouches[0].pageX);
    return;
  }
  const { params: o, touches: l, enabled: c } = e;
  if (
    !c ||
    (!o.simulateTouch && i.pointerType === "mouse") ||
    (e.animating && o.preventInteractionOnTransition)
  )
    return;
  !e.animating && o.cssMode && o.loop && e.loopFix();
  let u = i.target;
  if (
    (o.touchEventsTarget === "wrapper" && !Qa(u, e.wrapperEl)) ||
    ("which" in i && i.which === 3) ||
    ("button" in i && i.button > 0) ||
    (n.isTouched && n.isMoved)
  )
    return;
  const p = !!o.noSwipingClass && o.noSwipingClass !== "",
    h = i.composedPath ? i.composedPath() : i.path;
  p && i.target && i.target.shadowRoot && h && (u = h[0]);
  const m = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`,
    b = !!(i.target && i.target.shadowRoot);
  if (o.noSwiping && (b ? Gl(m, u) : u.closest(m))) {
    e.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !u.closest(o.swipeHandler)) return;
  ((l.currentX = i.pageX), (l.currentY = i.pageY));
  const w = l.currentX,
    S = l.currentY;
  if (!As(e, i, w)) return;
  (Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0,
  }),
    (l.startX = w),
    (l.startY = S),
    (n.touchStartTime = Cn()),
    (e.allowClick = !0),
    e.updateSize(),
    (e.swipeDirection = void 0),
    o.threshold > 0 && (n.allowThresholdMove = !1));
  let E = !0;
  (u.matches(n.focusableElements) &&
    ((E = !1), u.nodeName === "SELECT" && (n.isTouched = !1)),
    t.activeElement &&
      t.activeElement.matches(n.focusableElements) &&
      t.activeElement !== u &&
      (i.pointerType === "mouse" ||
        (i.pointerType !== "mouse" && !u.matches(n.focusableElements))) &&
      t.activeElement.blur());
  const P = E && e.allowTouchMove && o.touchStartPreventDefault;
  ((o.touchStartForcePreventDefault || P) &&
    !u.isContentEditable &&
    i.preventDefault(),
    o.freeMode &&
      o.freeMode.enabled &&
      e.freeMode &&
      e.animating &&
      !o.cssMode &&
      e.freeMode.onTouchStart(),
    e.emit("touchStart", i));
}
function Yl(s) {
  const e = ct(),
    t = this,
    i = t.touchEventsData,
    { params: n, touches: o, rtlTranslate: l, enabled: c } = t;
  if (!c || (!n.simulateTouch && s.pointerType === "mouse")) return;
  let u = s;
  if (
    (u.originalEvent && (u = u.originalEvent),
    u.type === "pointermove" &&
      (i.touchId !== null || u.pointerId !== i.pointerId))
  )
    return;
  let p;
  if (u.type === "touchmove") {
    if (
      ((p = [...u.changedTouches].find((_) => _.identifier === i.touchId)),
      !p || p.identifier !== i.touchId)
    )
      return;
  } else p = u;
  if (!i.isTouched) {
    i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", u);
    return;
  }
  const h = p.pageX,
    m = p.pageY;
  if (u.preventedByNestedSwiper) {
    ((o.startX = h), (o.startY = m));
    return;
  }
  if (!t.allowTouchMove) {
    (u.target.matches(i.focusableElements) || (t.allowClick = !1),
      i.isTouched &&
        (Object.assign(o, {
          startX: h,
          startY: m,
          currentX: h,
          currentY: m,
        }),
        (i.touchStartTime = Cn())));
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (t.isVertical()) {
      if (
        (m < o.startY && t.translate <= t.maxTranslate()) ||
        (m > o.startY && t.translate >= t.minTranslate())
      ) {
        ((i.isTouched = !1), (i.isMoved = !1));
        return;
      }
    } else if (
      (h < o.startX && t.translate <= t.maxTranslate()) ||
      (h > o.startX && t.translate >= t.minTranslate())
    )
      return;
  }
  if (
    (e.activeElement &&
      e.activeElement.matches(i.focusableElements) &&
      e.activeElement !== u.target &&
      u.pointerType !== "mouse" &&
      e.activeElement.blur(),
    e.activeElement &&
      u.target === e.activeElement &&
      u.target.matches(i.focusableElements))
  ) {
    ((i.isMoved = !0), (t.allowClick = !1));
    return;
  }
  (i.allowTouchCallbacks && t.emit("touchMove", u),
    (o.previousX = o.currentX),
    (o.previousY = o.currentY),
    (o.currentX = h),
    (o.currentY = m));
  const b = o.currentX - o.startX,
    w = o.currentY - o.startY;
  if (t.params.threshold && Math.sqrt(b ** 2 + w ** 2) < t.params.threshold)
    return;
  if (typeof i.isScrolling > "u") {
    let _;
    (t.isHorizontal() && o.currentY === o.startY) ||
    (t.isVertical() && o.currentX === o.startX)
      ? (i.isScrolling = !1)
      : b * b + w * w >= 25 &&
        ((_ = (Math.atan2(Math.abs(w), Math.abs(b)) * 180) / Math.PI),
        (i.isScrolling = t.isHorizontal()
          ? _ > n.touchAngle
          : 90 - _ > n.touchAngle));
  }
  if (
    (i.isScrolling && t.emit("touchMoveOpposite", u),
    typeof i.startMoving > "u" &&
      (o.currentX !== o.startX || o.currentY !== o.startY) &&
      (i.startMoving = !0),
    i.isScrolling ||
      (u.type === "touchmove" && i.preventTouchMoveFromPointerMove))
  ) {
    i.isTouched = !1;
    return;
  }
  if (!i.startMoving) return;
  ((t.allowClick = !1),
    !n.cssMode && u.cancelable && u.preventDefault(),
    n.touchMoveStopPropagation && !n.nested && u.stopPropagation());
  let S = t.isHorizontal() ? b : w,
    E = t.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  (n.oneWayMovement &&
    ((S = Math.abs(S) * (l ? 1 : -1)), (E = Math.abs(E) * (l ? 1 : -1))),
    (o.diff = S),
    (S *= n.touchRatio),
    l && ((S = -S), (E = -E)));
  const P = t.touchesDirection;
  ((t.swipeDirection = S > 0 ? "prev" : "next"),
    (t.touchesDirection = E > 0 ? "prev" : "next"));
  const T = t.params.loop && !n.cssMode,
    A =
      (t.touchesDirection === "next" && t.allowSlideNext) ||
      (t.touchesDirection === "prev" && t.allowSlidePrev);
  if (!i.isMoved) {
    if (
      (T &&
        A &&
        t.loopFix({
          direction: t.swipeDirection,
        }),
      (i.startTranslate = t.getTranslate()),
      t.setTransition(0),
      t.animating)
    ) {
      const _ = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0,
        },
      });
      t.wrapperEl.dispatchEvent(_);
    }
    ((i.allowMomentumBounce = !1),
      n.grabCursor &&
        (t.allowSlideNext === !0 || t.allowSlidePrev === !0) &&
        t.setGrabCursor(!0),
      t.emit("sliderFirstMove", u));
  }
  if (
    (new Date().getTime(),
    i.isMoved &&
      i.allowThresholdMove &&
      P !== t.touchesDirection &&
      T &&
      A &&
      Math.abs(S) >= 1)
  ) {
    (Object.assign(o, {
      startX: h,
      startY: m,
      currentX: h,
      currentY: m,
      startTranslate: i.currentTranslate,
    }),
      (i.loopSwapReset = !0),
      (i.startTranslate = i.currentTranslate));
    return;
  }
  (t.emit("sliderMove", u),
    (i.isMoved = !0),
    (i.currentTranslate = S + i.startTranslate));
  let O = !0,
    D = n.resistanceRatio;
  if (
    (n.touchReleaseOnEdges && (D = 0),
    S > 0
      ? (T &&
          A &&
          i.allowThresholdMove &&
          i.currentTranslate >
            (n.centeredSlides
              ? t.minTranslate() -
                t.slidesSizesGrid[t.activeIndex + 1] -
                (n.slidesPerView !== "auto" &&
                t.slides.length - n.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween
                  : 0) -
                t.params.spaceBetween
              : t.minTranslate()) &&
          t.loopFix({
            direction: "prev",
            setTranslate: !0,
            activeSlideIndex: 0,
          }),
        i.currentTranslate > t.minTranslate() &&
          ((O = !1),
          n.resistance &&
            (i.currentTranslate =
              t.minTranslate() -
              1 +
              (-t.minTranslate() + i.startTranslate + S) ** D)))
      : S < 0 &&
        (T &&
          A &&
          i.allowThresholdMove &&
          i.currentTranslate <
            (n.centeredSlides
              ? t.maxTranslate() +
                t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                t.params.spaceBetween +
                (n.slidesPerView !== "auto" &&
                t.slides.length - n.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                    t.params.spaceBetween
                  : 0)
              : t.maxTranslate()) &&
          t.loopFix({
            direction: "next",
            setTranslate: !0,
            activeSlideIndex:
              t.slides.length -
              (n.slidesPerView === "auto"
                ? t.slidesPerViewDynamic()
                : Math.ceil(parseFloat(n.slidesPerView, 10))),
          }),
        i.currentTranslate < t.maxTranslate() &&
          ((O = !1),
          n.resistance &&
            (i.currentTranslate =
              t.maxTranslate() +
              1 -
              (t.maxTranslate() - i.startTranslate - S) ** D))),
    O && (u.preventedByNestedSwiper = !0),
    !t.allowSlideNext &&
      t.swipeDirection === "next" &&
      i.currentTranslate < i.startTranslate &&
      (i.currentTranslate = i.startTranslate),
    !t.allowSlidePrev &&
      t.swipeDirection === "prev" &&
      i.currentTranslate > i.startTranslate &&
      (i.currentTranslate = i.startTranslate),
    !t.allowSlidePrev &&
      !t.allowSlideNext &&
      (i.currentTranslate = i.startTranslate),
    n.threshold > 0)
  )
    if (Math.abs(S) > n.threshold || i.allowThresholdMove) {
      if (!i.allowThresholdMove) {
        ((i.allowThresholdMove = !0),
          (o.startX = o.currentX),
          (o.startY = o.currentY),
          (i.currentTranslate = i.startTranslate),
          (o.diff = t.isHorizontal()
            ? o.currentX - o.startX
            : o.currentY - o.startY));
        return;
      }
    } else {
      i.currentTranslate = i.startTranslate;
      return;
    }
  !n.followFinger ||
    n.cssMode ||
    (((n.freeMode && n.freeMode.enabled && t.freeMode) ||
      n.watchSlidesProgress) &&
      (t.updateActiveIndex(), t.updateSlidesClasses()),
    n.freeMode && n.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
    t.updateProgress(i.currentTranslate),
    t.setTranslate(i.currentTranslate));
}
function Ul(s) {
  const e = this,
    t = e.touchEventsData;
  let i = s;
  i.originalEvent && (i = i.originalEvent);
  let n;
  if (i.type === "touchend" || i.type === "touchcancel") {
    if (
      ((n = [...i.changedTouches].find((_) => _.identifier === t.touchId)),
      !n || n.identifier !== t.touchId)
    )
      return;
  } else {
    if (t.touchId !== null || i.pointerId !== t.pointerId) return;
    n = i;
  }
  if (
    ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(
      i.type
    ) &&
    !(
      ["pointercancel", "contextmenu"].includes(i.type) &&
      (e.browser.isSafari || e.browser.isWebView)
    )
  )
    return;
  ((t.pointerId = null), (t.touchId = null));
  const {
    params: l,
    touches: c,
    rtlTranslate: u,
    slidesGrid: p,
    enabled: h,
  } = e;
  if (!h || (!l.simulateTouch && i.pointerType === "mouse")) return;
  if (
    (t.allowTouchCallbacks && e.emit("touchEnd", i),
    (t.allowTouchCallbacks = !1),
    !t.isTouched)
  ) {
    (t.isMoved && l.grabCursor && e.setGrabCursor(!1),
      (t.isMoved = !1),
      (t.startMoving = !1));
    return;
  }
  l.grabCursor &&
    t.isMoved &&
    t.isTouched &&
    (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
    e.setGrabCursor(!1);
  const m = Cn(),
    b = m - t.touchStartTime;
  if (e.allowClick) {
    const _ = i.path || (i.composedPath && i.composedPath());
    (e.updateClickedSlide((_ && _[0]) || i.target, _),
      e.emit("tap click", i),
      b < 300 &&
        m - t.lastClickTime < 300 &&
        e.emit("doubleTap doubleClick", i));
  }
  if (
    ((t.lastClickTime = Cn()),
    Tn(() => {
      e.destroyed || (e.allowClick = !0);
    }),
    !t.isTouched ||
      !t.isMoved ||
      !e.swipeDirection ||
      (c.diff === 0 && !t.loopSwapReset) ||
      (t.currentTranslate === t.startTranslate && !t.loopSwapReset))
  ) {
    ((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1));
    return;
  }
  ((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1));
  let w;
  if (
    (l.followFinger
      ? (w = u ? e.translate : -e.translate)
      : (w = -t.currentTranslate),
    l.cssMode)
  )
    return;
  if (l.freeMode && l.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: w,
    });
    return;
  }
  const S = w >= -e.maxTranslate() && !e.params.loop;
  let E = 0,
    P = e.slidesSizesGrid[0];
  for (
    let _ = 0;
    _ < p.length;
    _ += _ < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup
  ) {
    const X = _ < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    typeof p[_ + X] < "u"
      ? (S || (w >= p[_] && w < p[_ + X])) && ((E = _), (P = p[_ + X] - p[_]))
      : (S || w >= p[_]) && ((E = _), (P = p[p.length - 1] - p[p.length - 2]));
  }
  let T = null,
    A = null;
  l.rewind &&
    (e.isBeginning
      ? (A =
          l.virtual && l.virtual.enabled && e.virtual
            ? e.virtual.slides.length - 1
            : e.slides.length - 1)
      : e.isEnd && (T = 0));
  const O = (w - p[E]) / P,
    D = E < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
  if (b > l.longSwipesMs) {
    if (!l.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    (e.swipeDirection === "next" &&
      (O >= l.longSwipesRatio
        ? e.slideTo(l.rewind && e.isEnd ? T : E + D)
        : e.slideTo(E)),
      e.swipeDirection === "prev" &&
        (O > 1 - l.longSwipesRatio
          ? e.slideTo(E + D)
          : A !== null && O < 0 && Math.abs(O) > l.longSwipesRatio
            ? e.slideTo(A)
            : e.slideTo(E)));
  } else {
    if (!l.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation &&
    (i.target === e.navigation.nextEl || i.target === e.navigation.prevEl)
      ? i.target === e.navigation.nextEl
        ? e.slideTo(E + D)
        : e.slideTo(E)
      : (e.swipeDirection === "next" && e.slideTo(T !== null ? T : E + D),
        e.swipeDirection === "prev" && e.slideTo(A !== null ? A : E));
  }
}
function Ps() {
  const s = this,
    { params: e, el: t } = s;
  if (t && t.offsetWidth === 0) return;
  e.breakpoints && s.setBreakpoint();
  const { allowSlideNext: i, allowSlidePrev: n, snapGrid: o } = s,
    l = s.virtual && s.params.virtual.enabled;
  ((s.allowSlideNext = !0),
    (s.allowSlidePrev = !0),
    s.updateSize(),
    s.updateSlides(),
    s.updateSlidesClasses());
  const c = l && e.loop;
  ((e.slidesPerView === "auto" || e.slidesPerView > 1) &&
  s.isEnd &&
  !s.isBeginning &&
  !s.params.centeredSlides &&
  !c
    ? s.slideTo(s.slides.length - 1, 0, !1, !0)
    : s.params.loop && !l
      ? s.slideToLoop(s.realIndex, 0, !1, !0)
      : s.slideTo(s.activeIndex, 0, !1, !0),
    s.autoplay &&
      s.autoplay.running &&
      s.autoplay.paused &&
      (clearTimeout(s.autoplay.resizeTimeout),
      (s.autoplay.resizeTimeout = setTimeout(() => {
        s.autoplay &&
          s.autoplay.running &&
          s.autoplay.paused &&
          s.autoplay.resume();
      }, 500))),
    (s.allowSlidePrev = n),
    (s.allowSlideNext = i),
    s.params.watchOverflow && o !== s.snapGrid && s.checkOverflow());
}
function Zl(s) {
  const e = this;
  e.enabled &&
    (e.allowClick ||
      (e.params.preventClicks && s.preventDefault(),
      e.params.preventClicksPropagation &&
        e.animating &&
        (s.stopPropagation(), s.stopImmediatePropagation())));
}
function Kl() {
  const s = this,
    { wrapperEl: e, rtlTranslate: t, enabled: i } = s;
  if (!i) return;
  ((s.previousTranslate = s.translate),
    s.isHorizontal()
      ? (s.translate = -e.scrollLeft)
      : (s.translate = -e.scrollTop),
    s.translate === 0 && (s.translate = 0),
    s.updateActiveIndex(),
    s.updateSlidesClasses());
  let n;
  const o = s.maxTranslate() - s.minTranslate();
  (o === 0 ? (n = 0) : (n = (s.translate - s.minTranslate()) / o),
    n !== s.progress && s.updateProgress(t ? -s.translate : s.translate),
    s.emit("setTranslate", s.translate, !1));
}
function Ql(s) {
  const e = this;
  (xn(e, s.target),
    !(
      e.params.cssMode ||
      (e.params.slidesPerView !== "auto" && !e.params.autoHeight)
    ) && e.update());
}
function Jl() {
  const s = this;
  s.documentTouchHandlerProceeded ||
    ((s.documentTouchHandlerProceeded = !0),
    s.params.touchReleaseOnEdges && (s.el.style.touchAction = "auto"));
}
const Po = (s, e) => {
  const t = ct(),
    { params: i, el: n, wrapperEl: o, device: l } = s,
    c = !!i.nested,
    u = e === "on" ? "addEventListener" : "removeEventListener",
    p = e;
  !n ||
    typeof n == "string" ||
    (t[u]("touchstart", s.onDocumentTouchStart, {
      passive: !1,
      capture: c,
    }),
    n[u]("touchstart", s.onTouchStart, {
      passive: !1,
    }),
    n[u]("pointerdown", s.onTouchStart, {
      passive: !1,
    }),
    t[u]("touchmove", s.onTouchMove, {
      passive: !1,
      capture: c,
    }),
    t[u]("pointermove", s.onTouchMove, {
      passive: !1,
      capture: c,
    }),
    t[u]("touchend", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("pointerup", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("pointercancel", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("touchcancel", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("pointerout", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("pointerleave", s.onTouchEnd, {
      passive: !0,
    }),
    t[u]("contextmenu", s.onTouchEnd, {
      passive: !0,
    }),
    (i.preventClicks || i.preventClicksPropagation) &&
      n[u]("click", s.onClick, !0),
    i.cssMode && o[u]("scroll", s.onScroll),
    i.updateOnWindowResize
      ? s[p](
          l.ios || l.android
            ? "resize orientationchange observerUpdate"
            : "resize observerUpdate",
          Ps,
          !0
        )
      : s[p]("observerUpdate", Ps, !0),
    n[u]("load", s.onLoad, {
      capture: !0,
    }));
};
function ec() {
  const s = this,
    { params: e } = s;
  ((s.onTouchStart = Xl.bind(s)),
    (s.onTouchMove = Yl.bind(s)),
    (s.onTouchEnd = Ul.bind(s)),
    (s.onDocumentTouchStart = Jl.bind(s)),
    e.cssMode && (s.onScroll = Kl.bind(s)),
    (s.onClick = Zl.bind(s)),
    (s.onLoad = Ql.bind(s)),
    Po(s, "on"));
}
function tc() {
  Po(this, "off");
}
var ic = {
  attachEvents: ec,
  detachEvents: tc,
};
const Ls = (s, e) => s.grid && e.grid && e.grid.rows > 1;
function nc() {
  const s = this,
    { realIndex: e, initialized: t, params: i, el: n } = s,
    o = i.breakpoints;
  if (!o || (o && Object.keys(o).length === 0)) return;
  const l = ct(),
    c =
      i.breakpointsBase === "window" || !i.breakpointsBase
        ? i.breakpointsBase
        : "container",
    u =
      ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase
        ? s.el
        : l.querySelector(i.breakpointsBase),
    p = s.getBreakpoint(o, c, u);
  if (!p || s.currentBreakpoint === p) return;
  const m = (p in o ? o[p] : void 0) || s.originalParams,
    b = Ls(s, i),
    w = Ls(s, m),
    S = s.params.grabCursor,
    E = m.grabCursor,
    P = i.enabled;
  (b && !w
    ? (n.classList.remove(
        `${i.containerModifierClass}grid`,
        `${i.containerModifierClass}grid-column`
      ),
      s.emitContainerClasses())
    : !b &&
      w &&
      (n.classList.add(`${i.containerModifierClass}grid`),
      ((m.grid.fill && m.grid.fill === "column") ||
        (!m.grid.fill && i.grid.fill === "column")) &&
        n.classList.add(`${i.containerModifierClass}grid-column`),
      s.emitContainerClasses()),
    S && !E ? s.unsetGrabCursor() : !S && E && s.setGrabCursor(),
    ["navigation", "pagination", "scrollbar"].forEach((X) => {
      if (typeof m[X] > "u") return;
      const f = i[X] && i[X].enabled,
        J = m[X] && m[X].enabled;
      (f && !J && s[X].disable(), !f && J && s[X].enable());
    }));
  const T = m.direction && m.direction !== i.direction,
    A = i.loop && (m.slidesPerView !== i.slidesPerView || T),
    O = i.loop;
  (T && t && s.changeDirection(), lt(s.params, m));
  const D = s.params.enabled,
    _ = s.params.loop;
  (Object.assign(s, {
    allowTouchMove: s.params.allowTouchMove,
    allowSlideNext: s.params.allowSlideNext,
    allowSlidePrev: s.params.allowSlidePrev,
  }),
    P && !D ? s.disable() : !P && D && s.enable(),
    (s.currentBreakpoint = p),
    s.emit("_beforeBreakpoint", m),
    t &&
      (A
        ? (s.loopDestroy(), s.loopCreate(e), s.updateSlides())
        : !O && _
          ? (s.loopCreate(e), s.updateSlides())
          : O && !_ && s.loopDestroy()),
    s.emit("breakpoint", m));
}
function rc(s, e, t) {
  if ((e === void 0 && (e = "window"), !s || (e === "container" && !t))) return;
  let i = !1;
  const n = Ye(),
    o = e === "window" ? n.innerHeight : t.clientHeight,
    l = Object.keys(s).map((c) => {
      if (typeof c == "string" && c.indexOf("@") === 0) {
        const u = parseFloat(c.substr(1));
        return {
          value: o * u,
          point: c,
        };
      }
      return {
        value: c,
        point: c,
      };
    });
  l.sort((c, u) => parseInt(c.value, 10) - parseInt(u.value, 10));
  for (let c = 0; c < l.length; c += 1) {
    const { point: u, value: p } = l[c];
    e === "window"
      ? n.matchMedia(`(min-width: ${p}px)`).matches && (i = u)
      : p <= t.clientWidth && (i = u);
  }
  return i || "max";
}
var sc = {
  setBreakpoint: nc,
  getBreakpoint: rc,
};
function oc(s, e) {
  const t = [];
  return (
    s.forEach((i) => {
      typeof i == "object"
        ? Object.keys(i).forEach((n) => {
            i[n] && t.push(e + n);
          })
        : typeof i == "string" && t.push(e + i);
    }),
    t
  );
}
function ac() {
  const s = this,
    { classNames: e, params: t, rtl: i, el: n, device: o } = s,
    l = oc(
      [
        "initialized",
        t.direction,
        {
          "free-mode": s.params.freeMode && t.freeMode.enabled,
        },
        {
          autoheight: t.autoHeight,
        },
        {
          rtl: i,
        },
        {
          grid: t.grid && t.grid.rows > 1,
        },
        {
          "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column",
        },
        {
          android: o.android,
        },
        {
          ios: o.ios,
        },
        {
          "css-mode": t.cssMode,
        },
        {
          centered: t.cssMode && t.centeredSlides,
        },
        {
          "watch-progress": t.watchSlidesProgress,
        },
      ],
      t.containerModifierClass
    );
  (e.push(...l), n.classList.add(...e), s.emitContainerClasses());
}
function lc() {
  const s = this,
    { el: e, classNames: t } = s;
  !e ||
    typeof e == "string" ||
    (e.classList.remove(...t), s.emitContainerClasses());
}
var cc = {
  addClasses: ac,
  removeClasses: lc,
};
function uc() {
  const s = this,
    { isLocked: e, params: t } = s,
    { slidesOffsetBefore: i } = t;
  if (i) {
    const n = s.slides.length - 1,
      o = s.slidesGrid[n] + s.slidesSizesGrid[n] + i * 2;
    s.isLocked = s.size > o;
  } else s.isLocked = s.snapGrid.length === 1;
  (t.allowSlideNext === !0 && (s.allowSlideNext = !s.isLocked),
    t.allowSlidePrev === !0 && (s.allowSlidePrev = !s.isLocked),
    e && e !== s.isLocked && (s.isEnd = !1),
    e !== s.isLocked && s.emit(s.isLocked ? "lock" : "unlock"));
}
var dc = {
    checkOverflow: uc,
  },
  Ms = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
function fc(s, e) {
  return function (i) {
    i === void 0 && (i = {});
    const n = Object.keys(i)[0],
      o = i[n];
    if (typeof o != "object" || o === null) {
      lt(e, i);
      return;
    }
    if (
      (s[n] === !0 &&
        (s[n] = {
          enabled: !0,
        }),
      n === "navigation" &&
        s[n] &&
        s[n].enabled &&
        !s[n].prevEl &&
        !s[n].nextEl &&
        (s[n].auto = !0),
      ["pagination", "scrollbar"].indexOf(n) >= 0 &&
        s[n] &&
        s[n].enabled &&
        !s[n].el &&
        (s[n].auto = !0),
      !(n in s && "enabled" in o))
    ) {
      lt(e, i);
      return;
    }
    (typeof s[n] == "object" && !("enabled" in s[n]) && (s[n].enabled = !0),
      s[n] ||
        (s[n] = {
          enabled: !1,
        }),
      lt(e, i));
  };
}
const fr = {
    eventsEmitter: cl,
    update: wl,
    translate: Al,
    transition: Ol,
    slide: _l,
    loop: Hl,
    grabCursor: Wl,
    events: ic,
    breakpoints: sc,
    checkOverflow: dc,
    classes: cc,
  },
  hr = {};
class ze {
  constructor() {
    let e, t;
    for (var i = arguments.length, n = new Array(i), o = 0; o < i; o++)
      n[o] = arguments[o];
    (n.length === 1 &&
    n[0].constructor &&
    Object.prototype.toString.call(n[0]).slice(8, -1) === "Object"
      ? (t = n[0])
      : ([e, t] = n),
      t || (t = {}),
      (t = lt({}, t)),
      e && !t.el && (t.el = e));
    const l = ct();
    if (
      t.el &&
      typeof t.el == "string" &&
      l.querySelectorAll(t.el).length > 1
    ) {
      const h = [];
      return (
        l.querySelectorAll(t.el).forEach((m) => {
          const b = lt({}, t, {
            el: m,
          });
          h.push(new ze(b));
        }),
        h
      );
    }
    const c = this;
    ((c.__swiper__ = !0),
      (c.support = To()),
      (c.device = Co({
        userAgent: t.userAgent,
      })),
      (c.browser = ol()),
      (c.eventsListeners = {}),
      (c.eventsAnyListeners = []),
      (c.modules = [...c.__modules__]),
      t.modules && Array.isArray(t.modules) && c.modules.push(...t.modules));
    const u = {};
    c.modules.forEach((h) => {
      h({
        params: t,
        swiper: c,
        extendParams: fc(t, u),
        on: c.on.bind(c),
        once: c.once.bind(c),
        off: c.off.bind(c),
        emit: c.emit.bind(c),
      });
    });
    const p = lt({}, Ms, u);
    return (
      (c.params = lt({}, p, hr, t)),
      (c.originalParams = lt({}, c.params)),
      (c.passedParams = lt({}, t)),
      c.params &&
        c.params.on &&
        Object.keys(c.params.on).forEach((h) => {
          c.on(h, c.params.on[h]);
        }),
      c.params && c.params.onAny && c.onAny(c.params.onAny),
      Object.assign(c, {
        enabled: c.params.enabled,
        el: e,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal() {
          return c.params.direction === "horizontal";
        },
        isVertical() {
          return c.params.direction === "vertical";
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        allowSlideNext: c.params.allowSlideNext,
        allowSlidePrev: c.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: c.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null,
        },
        allowClick: !0,
        allowTouchMove: c.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },
        imagesToLoad: [],
        imagesLoaded: 0,
      }),
      c.emit("_swiper"),
      c.params.init && c.init(),
      c
    );
  }
  getDirectionLabel(e) {
    return this.isHorizontal()
      ? e
      : {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom",
        }[e];
  }
  getSlideIndex(e) {
    const { slidesEl: t, params: i } = this,
      n = Tt(t, `.${i.slideClass}, swiper-slide`),
      o = Pn(n[0]);
    return Pn(e) - o;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(
      this.slides.find(
        (t) => t.getAttribute("data-swiper-slide-index") * 1 === e
      )
    );
  }
  recalcSlides() {
    const e = this,
      { slidesEl: t, params: i } = e;
    e.slides = Tt(t, `.${i.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled ||
      ((e.enabled = !0),
      e.params.grabCursor && e.setGrabCursor(),
      e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled &&
      ((e.enabled = !1),
      e.params.grabCursor && e.unsetGrabCursor(),
      e.emit("disable"));
  }
  setProgress(e, t) {
    const i = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = i.minTranslate(),
      l = (i.maxTranslate() - n) * e + n;
    (i.translateTo(l, typeof t > "u" ? 0 : t),
      i.updateActiveIndex(),
      i.updateSlidesClasses());
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className
      .split(" ")
      .filter(
        (i) =>
          i.indexOf("swiper") === 0 ||
          i.indexOf(e.params.containerModifierClass) === 0
      );
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed
      ? ""
      : e.className
          .split(" ")
          .filter(
            (i) =>
              i.indexOf("swiper-slide") === 0 ||
              i.indexOf(t.params.slideClass) === 0
          )
          .join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    (e.slides.forEach((i) => {
      const n = e.getSlideClasses(i);
      (t.push({
        slideEl: i,
        classNames: n,
      }),
        e.emit("_slideClass", i, n));
    }),
      e.emit("_slideClasses", t));
  }
  slidesPerViewDynamic(e, t) {
    (e === void 0 && (e = "current"), t === void 0 && (t = !1));
    const i = this,
      {
        params: n,
        slides: o,
        slidesGrid: l,
        slidesSizesGrid: c,
        size: u,
        activeIndex: p,
      } = i;
    let h = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let m = o[p] ? Math.ceil(o[p].swiperSlideSize) : 0,
        b;
      for (let w = p + 1; w < o.length; w += 1)
        o[w] &&
          !b &&
          ((m += Math.ceil(o[w].swiperSlideSize)), (h += 1), m > u && (b = !0));
      for (let w = p - 1; w >= 0; w -= 1)
        o[w] &&
          !b &&
          ((m += o[w].swiperSlideSize), (h += 1), m > u && (b = !0));
    } else if (e === "current")
      for (let m = p + 1; m < o.length; m += 1)
        (t ? l[m] + c[m] - l[p] < u : l[m] - l[p] < u) && (h += 1);
    else for (let m = p - 1; m >= 0; m -= 1) l[p] - l[m] < u && (h += 1);
    return h;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const { snapGrid: t, params: i } = e;
    (i.breakpoints && e.setBreakpoint(),
      [...e.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
        l.complete && xn(e, l);
      }),
      e.updateSize(),
      e.updateSlides(),
      e.updateProgress(),
      e.updateSlidesClasses());
    function n() {
      const l = e.rtlTranslate ? e.translate * -1 : e.translate,
        c = Math.min(Math.max(l, e.maxTranslate()), e.minTranslate());
      (e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses());
    }
    let o;
    if (i.freeMode && i.freeMode.enabled && !i.cssMode)
      (n(), i.autoHeight && e.updateAutoHeight());
    else {
      if (
        (i.slidesPerView === "auto" || i.slidesPerView > 1) &&
        e.isEnd &&
        !i.centeredSlides
      ) {
        const l = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
        o = e.slideTo(l.length - 1, 0, !1, !0);
      } else o = e.slideTo(e.activeIndex, 0, !1, !0);
      o || n();
    }
    (i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
      e.emit("update"));
  }
  changeDirection(e, t) {
    t === void 0 && (t = !0);
    const i = this,
      n = i.params.direction;
    return (
      e || (e = n === "horizontal" ? "vertical" : "horizontal"),
      e === n ||
        (e !== "horizontal" && e !== "vertical") ||
        (i.el.classList.remove(`${i.params.containerModifierClass}${n}`),
        i.el.classList.add(`${i.params.containerModifierClass}${e}`),
        i.emitContainerClasses(),
        (i.params.direction = e),
        i.slides.forEach((o) => {
          e === "vertical" ? (o.style.width = "") : (o.style.height = "");
        }),
        i.emit("changeDirection"),
        t && i.update()),
      i
    );
  }
  changeLanguageDirection(e) {
    const t = this;
    (t.rtl && e === "rtl") ||
      (!t.rtl && e === "ltr") ||
      ((t.rtl = e === "rtl"),
      (t.rtlTranslate = t.params.direction === "horizontal" && t.rtl),
      t.rtl
        ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = "rtl"))
        : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = "ltr")),
      t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    let i = e || t.params.el;
    if ((typeof i == "string" && (i = document.querySelector(i)), !i))
      return !1;
    ((i.swiper = t),
      i.parentNode &&
        i.parentNode.host &&
        i.parentNode.host.nodeName ===
          t.params.swiperElementNodeName.toUpperCase() &&
        (t.isElement = !0));
    const n = () =>
      `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l =
      i && i.shadowRoot && i.shadowRoot.querySelector
        ? i.shadowRoot.querySelector(n())
        : Tt(i, n())[0];
    return (
      !l &&
        t.params.createElements &&
        ((l = Yi("div", t.params.wrapperClass)),
        i.append(l),
        Tt(i, `.${t.params.slideClass}`).forEach((c) => {
          l.append(c);
        })),
      Object.assign(t, {
        el: i,
        wrapperEl: l,
        slidesEl:
          t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : l,
        hostEl: t.isElement ? i.parentNode.host : i,
        mounted: !0,
        rtl: i.dir.toLowerCase() === "rtl" || Qt(i, "direction") === "rtl",
        rtlTranslate:
          t.params.direction === "horizontal" &&
          (i.dir.toLowerCase() === "rtl" || Qt(i, "direction") === "rtl"),
        wrongRTL: Qt(l, "display") === "-webkit-box",
      }),
      !0
    );
  }
  init(e) {
    const t = this;
    if (t.initialized || t.mount(e) === !1) return t;
    (t.emit("beforeInit"),
      t.params.breakpoints && t.setBreakpoint(),
      t.addClasses(),
      t.updateSize(),
      t.updateSlides(),
      t.params.watchOverflow && t.checkOverflow(),
      t.params.grabCursor && t.enabled && t.setGrabCursor(),
      t.params.loop && t.virtual && t.params.virtual.enabled
        ? t.slideTo(
            t.params.initialSlide + t.virtual.slidesBefore,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0
          )
        : t.slideTo(
            t.params.initialSlide,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0
          ),
      t.params.loop && t.loopCreate(),
      t.attachEvents());
    const n = [...t.el.querySelectorAll('[loading="lazy"]')];
    return (
      t.isElement && n.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
      n.forEach((o) => {
        o.complete
          ? xn(t, o)
          : o.addEventListener("load", (l) => {
              xn(t, l.target);
            });
      }),
      zr(t),
      (t.initialized = !0),
      zr(t),
      t.emit("init"),
      t.emit("afterInit"),
      t
    );
  }
  destroy(e, t) {
    (e === void 0 && (e = !0), t === void 0 && (t = !0));
    const i = this,
      { params: n, el: o, wrapperEl: l, slides: c } = i;
    return (
      typeof i.params > "u" ||
        i.destroyed ||
        (i.emit("beforeDestroy"),
        (i.initialized = !1),
        i.detachEvents(),
        n.loop && i.loopDestroy(),
        t &&
          (i.removeClasses(),
          o && typeof o != "string" && o.removeAttribute("style"),
          l && l.removeAttribute("style"),
          c &&
            c.length &&
            c.forEach((u) => {
              (u.classList.remove(
                n.slideVisibleClass,
                n.slideFullyVisibleClass,
                n.slideActiveClass,
                n.slideNextClass,
                n.slidePrevClass
              ),
                u.removeAttribute("style"),
                u.removeAttribute("data-swiper-slide-index"));
            })),
        i.emit("destroy"),
        Object.keys(i.eventsListeners).forEach((u) => {
          i.off(u);
        }),
        e !== !1 &&
          (i.el && typeof i.el != "string" && (i.el.swiper = null), Xa(i)),
        (i.destroyed = !0)),
      null
    );
  }
  static extendDefaults(e) {
    lt(hr, e);
  }
  static get extendedDefaults() {
    return hr;
  }
  static get defaults() {
    return Ms;
  }
  static installModule(e) {
    ze.prototype.__modules__ || (ze.prototype.__modules__ = []);
    const t = ze.prototype.__modules__;
    typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e)
      ? (e.forEach((t) => ze.installModule(t)), ze)
      : (ze.installModule(e), ze);
  }
}
(Object.keys(fr).forEach((s) => {
  Object.keys(fr[s]).forEach((e) => {
    ze.prototype[e] = fr[s][e];
  });
}),
  ze.use([al, ll]));
function jr(s, e, t, i) {
  return (
    s.params.createElements &&
      Object.keys(i).forEach((n) => {
        if (!t[n] && t.auto === !0) {
          let o = Tt(s.el, `.${i[n]}`)[0];
          (o || ((o = Yi("div", i[n])), (o.className = i[n]), s.el.append(o)),
            (t[n] = o),
            (e[n] = o));
        }
      }),
    t
  );
}
function qt(s) {
  let { swiper: e, extendParams: t, on: i, emit: n } = s;
  (t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled",
    },
  }),
    (e.navigation = {
      nextEl: null,
      prevEl: null,
    }));
  function o(S) {
    let E;
    return S &&
      typeof S == "string" &&
      e.isElement &&
      ((E = e.el.querySelector(S) || e.hostEl.querySelector(S)), E)
      ? E
      : (S &&
          (typeof S == "string" && (E = [...document.querySelectorAll(S)]),
          e.params.uniqueNavElements &&
          typeof S == "string" &&
          E &&
          E.length > 1 &&
          e.el.querySelectorAll(S).length === 1
            ? (E = e.el.querySelector(S))
            : E && E.length === 1 && (E = E[0])),
        S && !E ? S : E);
  }
  function l(S, E) {
    const P = e.params.navigation;
    ((S = je(S)),
      S.forEach((T) => {
        T &&
          (T.classList[E ? "add" : "remove"](...P.disabledClass.split(" ")),
          T.tagName === "BUTTON" && (T.disabled = E),
          e.params.watchOverflow &&
            e.enabled &&
            T.classList[e.isLocked ? "add" : "remove"](P.lockClass));
      }));
  }
  function c() {
    const { nextEl: S, prevEl: E } = e.navigation;
    if (e.params.loop) {
      (l(E, !1), l(S, !1));
      return;
    }
    (l(E, e.isBeginning && !e.params.rewind),
      l(S, e.isEnd && !e.params.rewind));
  }
  function u(S) {
    (S.preventDefault(),
      !(e.isBeginning && !e.params.loop && !e.params.rewind) &&
        (e.slidePrev(), n("navigationPrev")));
  }
  function p(S) {
    (S.preventDefault(),
      !(e.isEnd && !e.params.loop && !e.params.rewind) &&
        (e.slideNext(), n("navigationNext")));
  }
  function h() {
    const S = e.params.navigation;
    if (
      ((e.params.navigation = jr(
        e,
        e.originalParams.navigation,
        e.params.navigation,
        {
          nextEl: "swiper-button-next",
          prevEl: "swiper-button-prev",
        }
      )),
      !(S.nextEl || S.prevEl))
    )
      return;
    let E = o(S.nextEl),
      P = o(S.prevEl);
    (Object.assign(e.navigation, {
      nextEl: E,
      prevEl: P,
    }),
      (E = je(E)),
      (P = je(P)));
    const T = (A, O) => {
      (A && A.addEventListener("click", O === "next" ? p : u),
        !e.enabled && A && A.classList.add(...S.lockClass.split(" ")));
    };
    (E.forEach((A) => T(A, "next")), P.forEach((A) => T(A, "prev")));
  }
  function m() {
    let { nextEl: S, prevEl: E } = e.navigation;
    ((S = je(S)), (E = je(E)));
    const P = (T, A) => {
      (T.removeEventListener("click", A === "next" ? p : u),
        T.classList.remove(...e.params.navigation.disabledClass.split(" ")));
    };
    (S.forEach((T) => P(T, "next")), E.forEach((T) => P(T, "prev")));
  }
  (i("init", () => {
    e.params.navigation.enabled === !1 ? w() : (h(), c());
  }),
    i("toEdge fromEdge lock unlock", () => {
      c();
    }),
    i("destroy", () => {
      m();
    }),
    i("enable disable", () => {
      let { nextEl: S, prevEl: E } = e.navigation;
      if (((S = je(S)), (E = je(E)), e.enabled)) {
        c();
        return;
      }
      [...S, ...E]
        .filter((P) => !!P)
        .forEach((P) => P.classList.add(e.params.navigation.lockClass));
    }),
    i("click", (S, E) => {
      let { nextEl: P, prevEl: T } = e.navigation;
      ((P = je(P)), (T = je(T)));
      const A = E.target;
      let O = T.includes(A) || P.includes(A);
      if (e.isElement && !O) {
        const D = E.path || (E.composedPath && E.composedPath());
        D && (O = D.find((_) => P.includes(_) || T.includes(_)));
      }
      if (e.params.navigation.hideOnClick && !O) {
        if (
          e.pagination &&
          e.params.pagination &&
          e.params.pagination.clickable &&
          (e.pagination.el === A || e.pagination.el.contains(A))
        )
          return;
        let D;
        (P.length
          ? (D = P[0].classList.contains(e.params.navigation.hiddenClass))
          : T.length &&
            (D = T[0].classList.contains(e.params.navigation.hiddenClass)),
          n(D === !0 ? "navigationShow" : "navigationHide"),
          [...P, ...T]
            .filter((_) => !!_)
            .forEach((_) =>
              _.classList.toggle(e.params.navigation.hiddenClass)
            ));
      }
    }));
  const b = () => {
      (e.el.classList.remove(
        ...e.params.navigation.navigationDisabledClass.split(" ")
      ),
        h(),
        c());
    },
    w = () => {
      (e.el.classList.add(
        ...e.params.navigation.navigationDisabledClass.split(" ")
      ),
        m());
    };
  Object.assign(e.navigation, {
    enable: b,
    disable: w,
    update: c,
    init: h,
    destroy: m,
  });
}
function Li(s) {
  return (
    s === void 0 && (s = ""),
    `.${s
      .trim()
      .replace(/([\.:!+\/])/g, "\\$1")
      .replace(/ /g, ".")}`
  );
}
function hi(s) {
  let { swiper: e, extendParams: t, on: i, emit: n } = s;
  const o = "swiper-pagination";
  (t({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (A) => A,
      formatFractionTotal: (A) => A,
      bulletClass: `${o}-bullet`,
      bulletActiveClass: `${o}-bullet-active`,
      modifierClass: `${o}-`,
      currentClass: `${o}-current`,
      totalClass: `${o}-total`,
      hiddenClass: `${o}-hidden`,
      progressbarFillClass: `${o}-progressbar-fill`,
      progressbarOppositeClass: `${o}-progressbar-opposite`,
      clickableClass: `${o}-clickable`,
      lockClass: `${o}-lock`,
      horizontalClass: `${o}-horizontal`,
      verticalClass: `${o}-vertical`,
      paginationDisabledClass: `${o}-disabled`,
    },
  }),
    (e.pagination = {
      el: null,
      bullets: [],
    }));
  let l,
    c = 0;
  function u() {
    return (
      !e.params.pagination.el ||
      !e.pagination.el ||
      (Array.isArray(e.pagination.el) && e.pagination.el.length === 0)
    );
  }
  function p(A, O) {
    const { bulletActiveClass: D } = e.params.pagination;
    A &&
      ((A = A[`${O === "prev" ? "previous" : "next"}ElementSibling`]),
      A &&
        (A.classList.add(`${D}-${O}`),
        (A = A[`${O === "prev" ? "previous" : "next"}ElementSibling`]),
        A && A.classList.add(`${D}-${O}-${O}`)));
  }
  function h(A, O, D) {
    if (((A = A % D), (O = O % D), O === A + 1)) return "next";
    if (O === A - 1) return "previous";
  }
  function m(A) {
    const O = A.target.closest(Li(e.params.pagination.bulletClass));
    if (!O) return;
    A.preventDefault();
    const D = Pn(O) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === D) return;
      const _ = h(e.realIndex, D, e.slides.length);
      _ === "next"
        ? e.slideNext()
        : _ === "previous"
          ? e.slidePrev()
          : e.slideToLoop(D);
    } else e.slideTo(D);
  }
  function b() {
    const A = e.rtl,
      O = e.params.pagination;
    if (u()) return;
    let D = e.pagination.el;
    D = je(D);
    let _, X;
    const f =
        e.virtual && e.params.virtual.enabled
          ? e.virtual.slides.length
          : e.slides.length,
      J = e.params.loop
        ? Math.ceil(f / e.params.slidesPerGroup)
        : e.snapGrid.length;
    if (
      (e.params.loop
        ? ((X = e.previousRealIndex || 0),
          (_ =
            e.params.slidesPerGroup > 1
              ? Math.floor(e.realIndex / e.params.slidesPerGroup)
              : e.realIndex))
        : typeof e.snapIndex < "u"
          ? ((_ = e.snapIndex), (X = e.previousSnapIndex))
          : ((X = e.previousIndex || 0), (_ = e.activeIndex || 0)),
      O.type === "bullets" &&
        e.pagination.bullets &&
        e.pagination.bullets.length > 0)
    ) {
      const G = e.pagination.bullets;
      let W, ie, H;
      if (
        (O.dynamicBullets &&
          ((l = Dr(G[0], e.isHorizontal() ? "width" : "height")),
          D.forEach((R) => {
            R.style[e.isHorizontal() ? "width" : "height"] =
              `${l * (O.dynamicMainBullets + 4)}px`;
          }),
          O.dynamicMainBullets > 1 &&
            X !== void 0 &&
            ((c += _ - (X || 0)),
            c > O.dynamicMainBullets - 1
              ? (c = O.dynamicMainBullets - 1)
              : c < 0 && (c = 0)),
          (W = Math.max(_ - c, 0)),
          (ie = W + (Math.min(G.length, O.dynamicMainBullets) - 1)),
          (H = (ie + W) / 2)),
        G.forEach((R) => {
          const V = [
            ...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(
              (Q) => `${O.bulletActiveClass}${Q}`
            ),
          ]
            .map((Q) =>
              typeof Q == "string" && Q.includes(" ") ? Q.split(" ") : Q
            )
            .flat();
          R.classList.remove(...V);
        }),
        D.length > 1)
      )
        G.forEach((R) => {
          const V = Pn(R);
          (V === _
            ? R.classList.add(...O.bulletActiveClass.split(" "))
            : e.isElement && R.setAttribute("part", "bullet"),
            O.dynamicBullets &&
              (V >= W &&
                V <= ie &&
                R.classList.add(...`${O.bulletActiveClass}-main`.split(" ")),
              V === W && p(R, "prev"),
              V === ie && p(R, "next")));
        });
      else {
        const R = G[_];
        if (
          (R && R.classList.add(...O.bulletActiveClass.split(" ")),
          e.isElement &&
            G.forEach((V, Q) => {
              V.setAttribute("part", Q === _ ? "bullet-active" : "bullet");
            }),
          O.dynamicBullets)
        ) {
          const V = G[W],
            Q = G[ie];
          for (let ce = W; ce <= ie; ce += 1)
            G[ce] &&
              G[ce].classList.add(...`${O.bulletActiveClass}-main`.split(" "));
          (p(V, "prev"), p(Q, "next"));
        }
      }
      if (O.dynamicBullets) {
        const R = Math.min(G.length, O.dynamicMainBullets + 4),
          V = (l * R - l) / 2 - H * l,
          Q = A ? "right" : "left";
        G.forEach((ce) => {
          ce.style[e.isHorizontal() ? Q : "top"] = `${V}px`;
        });
      }
    }
    D.forEach((G, W) => {
      if (
        (O.type === "fraction" &&
          (G.querySelectorAll(Li(O.currentClass)).forEach((ie) => {
            ie.textContent = O.formatFractionCurrent(_ + 1);
          }),
          G.querySelectorAll(Li(O.totalClass)).forEach((ie) => {
            ie.textContent = O.formatFractionTotal(J);
          })),
        O.type === "progressbar")
      ) {
        let ie;
        O.progressbarOpposite
          ? (ie = e.isHorizontal() ? "vertical" : "horizontal")
          : (ie = e.isHorizontal() ? "horizontal" : "vertical");
        const H = (_ + 1) / J;
        let R = 1,
          V = 1;
        (ie === "horizontal" ? (R = H) : (V = H),
          G.querySelectorAll(Li(O.progressbarFillClass)).forEach((Q) => {
            ((Q.style.transform = `translate3d(0,0,0) scaleX(${R}) scaleY(${V})`),
              (Q.style.transitionDuration = `${e.params.speed}ms`));
          }));
      }
      (O.type === "custom" && O.renderCustom
        ? ((G.innerHTML = O.renderCustom(e, _ + 1, J)),
          W === 0 && n("paginationRender", G))
        : (W === 0 && n("paginationRender", G), n("paginationUpdate", G)),
        e.params.watchOverflow &&
          e.enabled &&
          G.classList[e.isLocked ? "add" : "remove"](O.lockClass));
    });
  }
  function w() {
    const A = e.params.pagination;
    if (u()) return;
    const O =
      e.virtual && e.params.virtual.enabled
        ? e.virtual.slides.length
        : e.grid && e.params.grid.rows > 1
          ? e.slides.length / Math.ceil(e.params.grid.rows)
          : e.slides.length;
    let D = e.pagination.el;
    D = je(D);
    let _ = "";
    if (A.type === "bullets") {
      let X = e.params.loop
        ? Math.ceil(O / e.params.slidesPerGroup)
        : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && X > O && (X = O);
      for (let f = 0; f < X; f += 1)
        A.renderBullet
          ? (_ += A.renderBullet.call(e, f, A.bulletClass))
          : (_ += `<${A.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${A.bulletClass}"></${A.bulletElement}>`);
    }
    (A.type === "fraction" &&
      (A.renderFraction
        ? (_ = A.renderFraction.call(e, A.currentClass, A.totalClass))
        : (_ = `<span class="${A.currentClass}"></span> / <span class="${A.totalClass}"></span>`)),
      A.type === "progressbar" &&
        (A.renderProgressbar
          ? (_ = A.renderProgressbar.call(e, A.progressbarFillClass))
          : (_ = `<span class="${A.progressbarFillClass}"></span>`)),
      (e.pagination.bullets = []),
      D.forEach((X) => {
        (A.type !== "custom" && (X.innerHTML = _ || ""),
          A.type === "bullets" &&
            e.pagination.bullets.push(
              ...X.querySelectorAll(Li(A.bulletClass))
            ));
      }),
      A.type !== "custom" && n("paginationRender", D[0]));
  }
  function S() {
    e.params.pagination = jr(
      e,
      e.originalParams.pagination,
      e.params.pagination,
      {
        el: "swiper-pagination",
      }
    );
    const A = e.params.pagination;
    if (!A.el) return;
    let O;
    (typeof A.el == "string" && e.isElement && (O = e.el.querySelector(A.el)),
      !O &&
        typeof A.el == "string" &&
        (O = [...document.querySelectorAll(A.el)]),
      O || (O = A.el),
      !(!O || O.length === 0) &&
        (e.params.uniqueNavElements &&
          typeof A.el == "string" &&
          Array.isArray(O) &&
          O.length > 1 &&
          ((O = [...e.el.querySelectorAll(A.el)]),
          O.length > 1 && (O = O.find((D) => Eo(D, ".swiper")[0] === e.el))),
        Array.isArray(O) && O.length === 1 && (O = O[0]),
        Object.assign(e.pagination, {
          el: O,
        }),
        (O = je(O)),
        O.forEach((D) => {
          (A.type === "bullets" &&
            A.clickable &&
            D.classList.add(...(A.clickableClass || "").split(" ")),
            D.classList.add(A.modifierClass + A.type),
            D.classList.add(
              e.isHorizontal() ? A.horizontalClass : A.verticalClass
            ),
            A.type === "bullets" &&
              A.dynamicBullets &&
              (D.classList.add(`${A.modifierClass}${A.type}-dynamic`),
              (c = 0),
              A.dynamicMainBullets < 1 && (A.dynamicMainBullets = 1)),
            A.type === "progressbar" &&
              A.progressbarOpposite &&
              D.classList.add(A.progressbarOppositeClass),
            A.clickable && D.addEventListener("click", m),
            e.enabled || D.classList.add(A.lockClass));
        })));
  }
  function E() {
    const A = e.params.pagination;
    if (u()) return;
    let O = e.pagination.el;
    (O &&
      ((O = je(O)),
      O.forEach((D) => {
        (D.classList.remove(A.hiddenClass),
          D.classList.remove(A.modifierClass + A.type),
          D.classList.remove(
            e.isHorizontal() ? A.horizontalClass : A.verticalClass
          ),
          A.clickable &&
            (D.classList.remove(...(A.clickableClass || "").split(" ")),
            D.removeEventListener("click", m)));
      })),
      e.pagination.bullets &&
        e.pagination.bullets.forEach((D) =>
          D.classList.remove(...A.bulletActiveClass.split(" "))
        ));
  }
  (i("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const A = e.params.pagination;
    let { el: O } = e.pagination;
    ((O = je(O)),
      O.forEach((D) => {
        (D.classList.remove(A.horizontalClass, A.verticalClass),
          D.classList.add(
            e.isHorizontal() ? A.horizontalClass : A.verticalClass
          ));
      }));
  }),
    i("init", () => {
      e.params.pagination.enabled === !1 ? T() : (S(), w(), b());
    }),
    i("activeIndexChange", () => {
      typeof e.snapIndex > "u" && b();
    }),
    i("snapIndexChange", () => {
      b();
    }),
    i("snapGridLengthChange", () => {
      (w(), b());
    }),
    i("destroy", () => {
      E();
    }),
    i("enable disable", () => {
      let { el: A } = e.pagination;
      A &&
        ((A = je(A)),
        A.forEach((O) =>
          O.classList[e.enabled ? "remove" : "add"](
            e.params.pagination.lockClass
          )
        ));
    }),
    i("lock unlock", () => {
      b();
    }),
    i("click", (A, O) => {
      const D = O.target,
        _ = je(e.pagination.el);
      if (
        e.params.pagination.el &&
        e.params.pagination.hideOnClick &&
        _ &&
        _.length > 0 &&
        !D.classList.contains(e.params.pagination.bulletClass)
      ) {
        if (
          e.navigation &&
          ((e.navigation.nextEl && D === e.navigation.nextEl) ||
            (e.navigation.prevEl && D === e.navigation.prevEl))
        )
          return;
        const X = _[0].classList.contains(e.params.pagination.hiddenClass);
        (n(X === !0 ? "paginationShow" : "paginationHide"),
          _.forEach((f) =>
            f.classList.toggle(e.params.pagination.hiddenClass)
          ));
      }
    }));
  const P = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let { el: A } = e.pagination;
      (A &&
        ((A = je(A)),
        A.forEach((O) =>
          O.classList.remove(e.params.pagination.paginationDisabledClass)
        )),
        S(),
        w(),
        b());
    },
    T = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let { el: A } = e.pagination;
      (A &&
        ((A = je(A)),
        A.forEach((O) =>
          O.classList.add(e.params.pagination.paginationDisabledClass)
        )),
        E());
    };
  Object.assign(e.pagination, {
    enable: P,
    disable: T,
    render: w,
    update: b,
    init: S,
    destroy: E,
  });
}
function hc(s) {
  let { swiper: e, extendParams: t, on: i, emit: n } = s;
  const o = ct();
  let l = !1,
    c = null,
    u = null,
    p,
    h,
    m,
    b;
  (t({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical",
    },
  }),
    (e.scrollbar = {
      el: null,
      dragEl: null,
    }));
  function w() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const { scrollbar: H, rtlTranslate: R } = e,
      { dragEl: V, el: Q } = H,
      ce = e.params.scrollbar,
      Ce = e.params.loop ? e.progressLoop : e.progress;
    let Y = h,
      U = (m - h) * Ce;
    (R
      ? ((U = -U), U > 0 ? ((Y = h - U), (U = 0)) : -U + h > m && (Y = m + U))
      : U < 0
        ? ((Y = h + U), (U = 0))
        : U + h > m && (Y = m - U),
      e.isHorizontal()
        ? ((V.style.transform = `translate3d(${U}px, 0, 0)`),
          (V.style.width = `${Y}px`))
        : ((V.style.transform = `translate3d(0px, ${U}px, 0)`),
          (V.style.height = `${Y}px`)),
      ce.hide &&
        (clearTimeout(c),
        (Q.style.opacity = 1),
        (c = setTimeout(() => {
          ((Q.style.opacity = 0), (Q.style.transitionDuration = "400ms"));
        }, 1e3))));
  }
  function S(H) {
    !e.params.scrollbar.el ||
      !e.scrollbar.el ||
      (e.scrollbar.dragEl.style.transitionDuration = `${H}ms`);
  }
  function E() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const { scrollbar: H } = e,
      { dragEl: R, el: V } = H;
    ((R.style.width = ""),
      (R.style.height = ""),
      (m = e.isHorizontal() ? V.offsetWidth : V.offsetHeight),
      (b =
        e.size /
        (e.virtualSize +
          e.params.slidesOffsetBefore -
          (e.params.centeredSlides ? e.snapGrid[0] : 0))),
      e.params.scrollbar.dragSize === "auto"
        ? (h = m * b)
        : (h = parseInt(e.params.scrollbar.dragSize, 10)),
      e.isHorizontal()
        ? (R.style.width = `${h}px`)
        : (R.style.height = `${h}px`),
      b >= 1 ? (V.style.display = "none") : (V.style.display = ""),
      e.params.scrollbar.hide && (V.style.opacity = 0),
      e.params.watchOverflow &&
        e.enabled &&
        H.el.classList[e.isLocked ? "add" : "remove"](
          e.params.scrollbar.lockClass
        ));
  }
  function P(H) {
    return e.isHorizontal() ? H.clientX : H.clientY;
  }
  function T(H) {
    const { scrollbar: R, rtlTranslate: V } = e,
      { el: Q } = R;
    let ce;
    ((ce =
      (P(H) -
        Ja(Q)[e.isHorizontal() ? "left" : "top"] -
        (p !== null ? p : h / 2)) /
      (m - h)),
      (ce = Math.max(Math.min(ce, 1), 0)),
      V && (ce = 1 - ce));
    const Ce = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * ce;
    (e.updateProgress(Ce),
      e.setTranslate(Ce),
      e.updateActiveIndex(),
      e.updateSlidesClasses());
  }
  function A(H) {
    const R = e.params.scrollbar,
      { scrollbar: V, wrapperEl: Q } = e,
      { el: ce, dragEl: Ce } = V;
    ((l = !0),
      (p =
        H.target === Ce
          ? P(H) -
            H.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"]
          : null),
      H.preventDefault(),
      H.stopPropagation(),
      (Q.style.transitionDuration = "100ms"),
      (Ce.style.transitionDuration = "100ms"),
      T(H),
      clearTimeout(u),
      (ce.style.transitionDuration = "0ms"),
      R.hide && (ce.style.opacity = 1),
      e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"),
      n("scrollbarDragStart", H));
  }
  function O(H) {
    const { scrollbar: R, wrapperEl: V } = e,
      { el: Q, dragEl: ce } = R;
    l &&
      (H.preventDefault && H.cancelable
        ? H.preventDefault()
        : (H.returnValue = !1),
      T(H),
      (V.style.transitionDuration = "0ms"),
      (Q.style.transitionDuration = "0ms"),
      (ce.style.transitionDuration = "0ms"),
      n("scrollbarDragMove", H));
  }
  function D(H) {
    const R = e.params.scrollbar,
      { scrollbar: V, wrapperEl: Q } = e,
      { el: ce } = V;
    l &&
      ((l = !1),
      e.params.cssMode &&
        ((e.wrapperEl.style["scroll-snap-type"] = ""),
        (Q.style.transitionDuration = "")),
      R.hide &&
        (clearTimeout(u),
        (u = Tn(() => {
          ((ce.style.opacity = 0), (ce.style.transitionDuration = "400ms"));
        }, 1e3))),
      n("scrollbarDragEnd", H),
      R.snapOnRelease && e.slideToClosest());
  }
  function _(H) {
    const { scrollbar: R, params: V } = e,
      Q = R.el;
    if (!Q) return;
    const ce = Q,
      Ce = V.passiveListeners
        ? {
            passive: !1,
            capture: !1,
          }
        : !1,
      Y = V.passiveListeners
        ? {
            passive: !0,
            capture: !1,
          }
        : !1;
    if (!ce) return;
    const U = H === "on" ? "addEventListener" : "removeEventListener";
    (ce[U]("pointerdown", A, Ce),
      o[U]("pointermove", O, Ce),
      o[U]("pointerup", D, Y));
  }
  function X() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("on");
  }
  function f() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("off");
  }
  function J() {
    const { scrollbar: H, el: R } = e;
    e.params.scrollbar = jr(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar",
    });
    const V = e.params.scrollbar;
    if (!V.el) return;
    let Q;
    if (
      (typeof V.el == "string" && e.isElement && (Q = e.el.querySelector(V.el)),
      !Q && typeof V.el == "string")
    ) {
      if (((Q = o.querySelectorAll(V.el)), !Q.length)) return;
    } else Q || (Q = V.el);
    (e.params.uniqueNavElements &&
      typeof V.el == "string" &&
      Q.length > 1 &&
      R.querySelectorAll(V.el).length === 1 &&
      (Q = R.querySelector(V.el)),
      Q.length > 0 && (Q = Q[0]),
      Q.classList.add(e.isHorizontal() ? V.horizontalClass : V.verticalClass));
    let ce;
    (Q &&
      ((ce = Q.querySelector(Li(e.params.scrollbar.dragClass))),
      ce || ((ce = Yi("div", e.params.scrollbar.dragClass)), Q.append(ce))),
      Object.assign(H, {
        el: Q,
        dragEl: ce,
      }),
      V.draggable && X(),
      Q &&
        Q.classList[e.enabled ? "remove" : "add"](
          ...Kt(e.params.scrollbar.lockClass)
        ));
  }
  function G() {
    const H = e.params.scrollbar,
      R = e.scrollbar.el;
    (R &&
      R.classList.remove(
        ...Kt(e.isHorizontal() ? H.horizontalClass : H.verticalClass)
      ),
      f());
  }
  (i("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const H = e.params.scrollbar;
    let { el: R } = e.scrollbar;
    ((R = je(R)),
      R.forEach((V) => {
        (V.classList.remove(H.horizontalClass, H.verticalClass),
          V.classList.add(
            e.isHorizontal() ? H.horizontalClass : H.verticalClass
          ));
      }));
  }),
    i("init", () => {
      e.params.scrollbar.enabled === !1 ? ie() : (J(), E(), w());
    }),
    i("update resize observerUpdate lock unlock changeDirection", () => {
      E();
    }),
    i("setTranslate", () => {
      w();
    }),
    i("setTransition", (H, R) => {
      S(R);
    }),
    i("enable disable", () => {
      const { el: H } = e.scrollbar;
      H &&
        H.classList[e.enabled ? "remove" : "add"](
          ...Kt(e.params.scrollbar.lockClass)
        );
    }),
    i("destroy", () => {
      G();
    }));
  const W = () => {
      (e.el.classList.remove(...Kt(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.remove(
            ...Kt(e.params.scrollbar.scrollbarDisabledClass)
          ),
        J(),
        E(),
        w());
    },
    ie = () => {
      (e.el.classList.add(...Kt(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.add(
            ...Kt(e.params.scrollbar.scrollbarDisabledClass)
          ),
        G());
    };
  Object.assign(e.scrollbar, {
    enable: W,
    disable: ie,
    updateSize: E,
    setTranslate: w,
    init: J,
    destroy: G,
  });
}
function kn(s) {
  let { swiper: e, extendParams: t, on: i, emit: n, params: o } = s;
  ((e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0,
  }),
    t({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !1,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    }));
  let l,
    c,
    u = o && o.autoplay ? o.autoplay.delay : 3e3,
    p = o && o.autoplay ? o.autoplay.delay : 3e3,
    h,
    m = new Date().getTime(),
    b,
    w,
    S,
    E,
    P,
    T,
    A;
  function O(Y) {
    !e ||
      e.destroyed ||
      !e.wrapperEl ||
      (Y.target === e.wrapperEl &&
        (e.wrapperEl.removeEventListener("transitionend", O),
        !(A || (Y.detail && Y.detail.bySwiperTouchMove)) && W()));
  }
  const D = () => {
      if (e.destroyed || !e.autoplay.running) return;
      e.autoplay.paused ? (b = !0) : b && ((p = h), (b = !1));
      const Y = e.autoplay.paused ? h : m + p - new Date().getTime();
      ((e.autoplay.timeLeft = Y),
        n("autoplayTimeLeft", Y, Y / u),
        (c = requestAnimationFrame(() => {
          D();
        })));
    },
    _ = () => {
      let Y;
      return (
        e.virtual && e.params.virtual.enabled
          ? (Y = e.slides.find((le) =>
              le.classList.contains("swiper-slide-active")
            ))
          : (Y = e.slides[e.activeIndex]),
        Y ? parseInt(Y.getAttribute("data-swiper-autoplay"), 10) : void 0
      );
    },
    X = (Y) => {
      if (e.destroyed || !e.autoplay.running) return;
      (cancelAnimationFrame(c), D());
      let U = typeof Y > "u" ? e.params.autoplay.delay : Y;
      ((u = e.params.autoplay.delay), (p = e.params.autoplay.delay));
      const le = _();
      (!Number.isNaN(le) &&
        le > 0 &&
        typeof Y > "u" &&
        ((U = le), (u = le), (p = le)),
        (h = U));
      const Te = e.params.speed,
        Pe = () => {
          !e ||
            e.destroyed ||
            (e.params.autoplay.reverseDirection
              ? !e.isBeginning || e.params.loop || e.params.rewind
                ? (e.slidePrev(Te, !0, !0), n("autoplay"))
                : e.params.autoplay.stopOnLastSlide ||
                  (e.slideTo(e.slides.length - 1, Te, !0, !0), n("autoplay"))
              : !e.isEnd || e.params.loop || e.params.rewind
                ? (e.slideNext(Te, !0, !0), n("autoplay"))
                : e.params.autoplay.stopOnLastSlide ||
                  (e.slideTo(0, Te, !0, !0), n("autoplay")),
            e.params.cssMode &&
              ((m = new Date().getTime()),
              requestAnimationFrame(() => {
                X();
              })));
        };
      return (
        U > 0
          ? (clearTimeout(l),
            (l = setTimeout(() => {
              Pe();
            }, U)))
          : requestAnimationFrame(() => {
              Pe();
            }),
        U
      );
    },
    f = () => {
      ((m = new Date().getTime()),
        (e.autoplay.running = !0),
        X(),
        n("autoplayStart"));
    },
    J = () => {
      ((e.autoplay.running = !1),
        clearTimeout(l),
        cancelAnimationFrame(c),
        n("autoplayStop"));
    },
    G = (Y, U) => {
      if (e.destroyed || !e.autoplay.running) return;
      (clearTimeout(l), Y || (T = !0));
      const le = () => {
        (n("autoplayPause"),
          e.params.autoplay.waitForTransition
            ? e.wrapperEl.addEventListener("transitionend", O)
            : W());
      };
      if (((e.autoplay.paused = !0), U)) {
        (P && (h = e.params.autoplay.delay), (P = !1), le());
        return;
      }
      ((h = (h || e.params.autoplay.delay) - (new Date().getTime() - m)),
        !(e.isEnd && h < 0 && !e.params.loop) && (h < 0 && (h = 0), le()));
    },
    W = () => {
      (e.isEnd && h < 0 && !e.params.loop) ||
        e.destroyed ||
        !e.autoplay.running ||
        ((m = new Date().getTime()),
        T ? ((T = !1), X(h)) : X(),
        (e.autoplay.paused = !1),
        n("autoplayResume"));
    },
    ie = () => {
      if (e.destroyed || !e.autoplay.running) return;
      const Y = ct();
      (Y.visibilityState === "hidden" && ((T = !0), G(!0)),
        Y.visibilityState === "visible" && W());
    },
    H = (Y) => {
      Y.pointerType === "mouse" &&
        ((T = !0), (A = !0), !(e.animating || e.autoplay.paused) && G(!0));
    },
    R = (Y) => {
      Y.pointerType === "mouse" && ((A = !1), e.autoplay.paused && W());
    },
    V = () => {
      e.params.autoplay.pauseOnMouseEnter &&
        (e.el.addEventListener("pointerenter", H),
        e.el.addEventListener("pointerleave", R));
    },
    Q = () => {
      e.el &&
        typeof e.el != "string" &&
        (e.el.removeEventListener("pointerenter", H),
        e.el.removeEventListener("pointerleave", R));
    },
    ce = () => {
      ct().addEventListener("visibilitychange", ie);
    },
    Ce = () => {
      ct().removeEventListener("visibilitychange", ie);
    };
  (i("init", () => {
    e.params.autoplay.enabled && (V(), ce(), f());
  }),
    i("destroy", () => {
      (Q(), Ce(), e.autoplay.running && J());
    }),
    i("_freeModeStaticRelease", () => {
      (S || T) && W();
    }),
    i("_freeModeNoMomentumRelease", () => {
      e.params.autoplay.disableOnInteraction ? J() : G(!0, !0);
    }),
    i("beforeTransitionStart", (Y, U, le) => {
      e.destroyed ||
        !e.autoplay.running ||
        (le || !e.params.autoplay.disableOnInteraction ? G(!0, !0) : J());
    }),
    i("sliderFirstMove", () => {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          J();
          return;
        }
        ((w = !0),
          (S = !1),
          (T = !1),
          (E = setTimeout(() => {
            ((T = !0), (S = !0), G(!0));
          }, 200)));
      }
    }),
    i("touchEnd", () => {
      if (!(e.destroyed || !e.autoplay.running || !w)) {
        if (
          (clearTimeout(E),
          clearTimeout(l),
          e.params.autoplay.disableOnInteraction)
        ) {
          ((S = !1), (w = !1));
          return;
        }
        (S && e.params.cssMode && W(), (S = !1), (w = !1));
      }
    }),
    i("slideChange", () => {
      e.destroyed || !e.autoplay.running || (P = !0);
    }),
    Object.assign(e.autoplay, {
      start: f,
      stop: J,
      pause: G,
      resume: W,
    }));
}
function pc(s) {
  let { swiper: e, extendParams: t, on: i } = s;
  t({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs",
    },
  });
  let n = !1,
    o = !1;
  e.thumbs = {
    swiper: null,
  };
  function l() {
    const p = e.thumbs.swiper;
    if (!p || p.destroyed) return;
    const h = p.clickedIndex,
      m = p.clickedSlide;
    if (
      (m && m.classList.contains(e.params.thumbs.slideThumbActiveClass)) ||
      typeof h > "u" ||
      h === null
    )
      return;
    let b;
    (p.params.loop
      ? (b = parseInt(
          p.clickedSlide.getAttribute("data-swiper-slide-index"),
          10
        ))
      : (b = h),
      e.params.loop ? e.slideToLoop(b) : e.slideTo(b));
  }
  function c() {
    const { thumbs: p } = e.params;
    if (n) return !1;
    n = !0;
    const h = e.constructor;
    if (p.swiper instanceof h)
      ((e.thumbs.swiper = p.swiper),
        Object.assign(e.thumbs.swiper.originalParams, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        Object.assign(e.thumbs.swiper.params, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        e.thumbs.swiper.update());
    else if (Bi(p.swiper)) {
      const m = Object.assign({}, p.swiper);
      (Object.assign(m, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1,
      }),
        (e.thumbs.swiper = new h(m)),
        (o = !0));
    }
    return (
      e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),
      e.thumbs.swiper.on("tap", l),
      !0
    );
  }
  function u(p) {
    const h = e.thumbs.swiper;
    if (!h || h.destroyed) return;
    const m =
      h.params.slidesPerView === "auto"
        ? h.slidesPerViewDynamic()
        : h.params.slidesPerView;
    let b = 1;
    const w = e.params.thumbs.slideThumbActiveClass;
    if (
      (e.params.slidesPerView > 1 &&
        !e.params.centeredSlides &&
        (b = e.params.slidesPerView),
      e.params.thumbs.multipleActiveThumbs || (b = 1),
      (b = Math.floor(b)),
      h.slides.forEach((P) => P.classList.remove(w)),
      h.params.loop || (h.params.virtual && h.params.virtual.enabled))
    )
      for (let P = 0; P < b; P += 1)
        Tt(
          h.slidesEl,
          `[data-swiper-slide-index="${e.realIndex + P}"]`
        ).forEach((T) => {
          T.classList.add(w);
        });
    else
      for (let P = 0; P < b; P += 1)
        h.slides[e.realIndex + P] && h.slides[e.realIndex + P].classList.add(w);
    const S = e.params.thumbs.autoScrollOffset,
      E = S && !h.params.loop;
    if (e.realIndex !== h.realIndex || E) {
      const P = h.activeIndex;
      let T, A;
      if (h.params.loop) {
        const O = h.slides.find(
          (D) => D.getAttribute("data-swiper-slide-index") === `${e.realIndex}`
        );
        ((T = h.slides.indexOf(O)),
          (A = e.activeIndex > e.previousIndex ? "next" : "prev"));
      } else ((T = e.realIndex), (A = T > e.previousIndex ? "next" : "prev"));
      (E && (T += A === "next" ? S : -1 * S),
        h.visibleSlidesIndexes &&
          h.visibleSlidesIndexes.indexOf(T) < 0 &&
          (h.params.centeredSlides
            ? T > P
              ? (T = T - Math.floor(m / 2) + 1)
              : (T = T + Math.floor(m / 2) - 1)
            : T > P && h.params.slidesPerGroup,
          h.slideTo(T, p ? 0 : void 0)));
    }
  }
  (i("beforeInit", () => {
    const { thumbs: p } = e.params;
    if (!(!p || !p.swiper))
      if (typeof p.swiper == "string" || p.swiper instanceof HTMLElement) {
        const h = ct(),
          m = () => {
            const w =
              typeof p.swiper == "string"
                ? h.querySelector(p.swiper)
                : p.swiper;
            if (w && w.swiper) ((p.swiper = w.swiper), c(), u(!0));
            else if (w) {
              const S = `${e.params.eventsPrefix}init`,
                E = (P) => {
                  ((p.swiper = P.detail[0]),
                    w.removeEventListener(S, E),
                    c(),
                    u(!0),
                    p.swiper.update(),
                    e.update());
                };
              w.addEventListener(S, E);
            }
            return w;
          },
          b = () => {
            e.destroyed || m() || requestAnimationFrame(b);
          };
        requestAnimationFrame(b);
      } else (c(), u(!0));
  }),
    i("slideChange update resize observerUpdate", () => {
      u();
    }),
    i("setTransition", (p, h) => {
      const m = e.thumbs.swiper;
      !m || m.destroyed || m.setTransition(h);
    }),
    i("beforeDestroy", () => {
      const p = e.thumbs.swiper;
      !p || p.destroyed || (o && p.destroy());
    }),
    Object.assign(e.thumbs, {
      init: c,
      update: u,
    }));
}
function gc(s) {
  const {
    effect: e,
    swiper: t,
    on: i,
    setTranslate: n,
    setTransition: o,
    overwriteParams: l,
    perspective: c,
    recreateShadows: u,
    getEffectParams: p,
  } = s;
  (i("beforeInit", () => {
    if (t.params.effect !== e) return;
    (t.classNames.push(`${t.params.containerModifierClass}${e}`),
      c && c() && t.classNames.push(`${t.params.containerModifierClass}3d`));
    const m = l ? l() : {};
    (Object.assign(t.params, m), Object.assign(t.originalParams, m));
  }),
    i("setTranslate", () => {
      t.params.effect === e && n();
    }),
    i("setTransition", (m, b) => {
      t.params.effect === e && o(b);
    }),
    i("transitionEnd", () => {
      if (t.params.effect === e && u) {
        if (!p || !p().slideShadows) return;
        (t.slides.forEach((m) => {
          m.querySelectorAll(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          ).forEach((b) => b.remove());
        }),
          u());
      }
    }));
  let h;
  i("virtualUpdate", () => {
    t.params.effect === e &&
      (t.slides.length || (h = !0),
      requestAnimationFrame(() => {
        h && t.slides && t.slides.length && (n(), (h = !1));
      }));
  });
}
function mc(s, e) {
  const t = xo(e);
  return (
    t !== e &&
      ((t.style.backfaceVisibility = "hidden"),
      (t.style["-webkit-backface-visibility"] = "hidden")),
    t
  );
}
function vc(s) {
  let { swiper: e, duration: t, transformElements: i } = s;
  const { activeIndex: n } = e;
  if (e.params.virtualTranslate && t !== 0) {
    let o = !1,
      l;
    ((l = i),
      l.forEach((c) => {
        il(c, () => {
          if (o || !e || e.destroyed) return;
          ((o = !0), (e.animating = !1));
          const u = new window.CustomEvent("transitionend", {
            bubbles: !0,
            cancelable: !0,
          });
          e.wrapperEl.dispatchEvent(u);
        });
      }));
  }
}
function Lo(s) {
  let { swiper: e, extendParams: t, on: i } = s;
  (t({
    fadeEffect: {
      crossFade: !1,
    },
  }),
    gc({
      effect: "fade",
      swiper: e,
      on: i,
      setTranslate: () => {
        const { slides: l } = e,
          c = e.params.fadeEffect;
        for (let u = 0; u < l.length; u += 1) {
          const p = e.slides[u];
          let m = -p.swiperSlideOffset;
          e.params.virtualTranslate || (m -= e.translate);
          let b = 0;
          e.isHorizontal() || ((b = m), (m = 0));
          const w = e.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(p.progress), 0)
              : 1 + Math.min(Math.max(p.progress, -1), 0),
            S = mc(c, p);
          ((S.style.opacity = w),
            (S.style.transform = `translate3d(${m}px, ${b}px, 0px)`));
        }
      },
      setTransition: (l) => {
        const c = e.slides.map((u) => xo(u));
        (c.forEach((u) => {
          u.style.transitionDuration = `${l}ms`;
        }),
          vc({
            swiper: e,
            duration: l,
            transformElements: c,
          }));
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !e.params.cssMode,
      }),
    }));
}
